import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import Overview from "../pages/Overview";
import MyInvestments from "../pages/MyInvestments";
import Subscribe from "../pages/Subscribe";
import Redeem from "../pages/Redeem";
import Transactions from "../pages/Transactions";
import BuyOrder from "../pages/buyOrder";
import SellOrder from "../pages/sellOrder";
import OrderStatus from "../pages/orderStatus";
import Transfer from "../pages/Transfer";
import Beneficiaries from "../pages/Beneficiaries";
import AccountStatement from "../pages/AccountStatement";
import InvestmentReport from "../pages/InvestmentReport";
import Contact from "../pages/Contact";
import Terms from "../pages/Terms";
import InformationSecurity from "../pages/InformationSecurity";
import Faqs from "../pages/Faqs";
import GeneralSettings from "../pages/GeneralSettings";
import TradingSettings from "../pages/TradingSettings";
import AvailableFunds from "../pages/AvailableFunds";
import MyFunds from "../pages/MyFunds";
// import FundReports from "../pages/FundReports";
import FundCustomerStatements from "../pages/FundCustomerStatements";
import CorporateForm from "../pages/CorporateForm";
import IndividualForm from "../pages/IndividualForm";
import AccountClosure from "../pages/AccountClosure";
import TicketingHistory from "../pages/TicketingHistory";
import PageNotFound from "../pages/PageNotFound";
import ErrorForbidden from "../pages/ErrorForbidden";
import images from "../constants/images";
import TopUp from "../pages/Topup";
import MyFundReports from "../pages/MyFundReports";
import ViewFundReport from "../pages/ViewFundReport";
import MyInvestmentsDetail from "../pages/MyInvestmentsDetail";
import dayjs from "dayjs";
import VatNumber from "../pages/VatNumber";

// QA
// export const join_us_link = 'http://cis-tharwat-qa.digitrends.us/';
// export const kyc_update_link = 'http://cis-tharwat-qa.digitrends.us/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true';

// UAT
export const join_us_link = "https://cis-tharwat-uat.digitrends.us/";
export const kyc_update_link = "http://cis-tharwat-uat.digitrends.us/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true";
export const kyc_update_link_client_classification = "http://cis-tharwat-uat.digitrends.us/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true&isClientClassification=true";

// Staging
// export const join_us_link = "https://cis-tharwat-staging.digitrends.us/";
// export const kyc_update_link = "http://cis-tharwat-staging.digitrends.us/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true";
// export const kyc_update_link_client_classification = "http://cis-tharwat-staging.digitrends.us/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true&isClientClassification=true";

// export const join_us_link = 'https://app.tharwat.sa/';
// export const kyc_update_link = 'https://app.tharwat.sa/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true';
// export const kyc_update_link_client_classification = "https://app.tharwat.sa/KycUpdateAuth/LoginKycUpdate?signInAndContinue=true&isClientClassification=true";

export const tadawul_login_link = "http://172.31.255.82:443";
export const tadawul_more_info_link =
  "https://www.saudiexchange.sa/wps/portal/saudiexchange/home/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8ziTR3NDIw8LAz83Z29TAwC_Rx9DSxdLY0MDAz1w_Wj9KOQlRgEB5gaBLoF-Br7GAQZuBuYQRUY4ACOBvoF2dmBAERHA9g!/dz/d5/L0lDUmlTUSEhL3dHa0FKRnNBLzROV3FpQSEhL2Vu/ [saudiexchange.sa]";

export const phoneRegex = /^\+?(\d\s?){10,18}$/;
export const lettersOnly = /^[A-Za-z\s]+$/;
export const digitsOnly = /^[0-9]+$/;
export const alphaNumeric = /^[A-Za-z0-9]+$/;
export const decimalNumber = /^\d{1,15}(\.\d{1,2})?$/;

// routes
export const routes = [
  {
    path: "/investments/overview",
    component: Overview,
  },
  {
    path: "/transfers/topup",
    component: TopUp,
  },
  // {
  //   path: '/investments/manage-investments/performance',
  //   component: Performance,
  // },
  // {
  //   path: '/investments/manage-investments/allocation',
  //   component: Allocation,
  // },
  {
    path: "/investments/manage-investments/my-investments",
    component: MyInvestments,
  },
  {
    path: "/investments/manage-investments/my-investments-detail",
    component: MyInvestmentsDetail,
  },

  {
    path: "/funds/available-funds",
    component: AvailableFunds,
  },
  {
    path: "/funds/my-funds",
    component: MyFunds,
  },
  {
    path: "/investments/reports",
    component: FundCustomerStatements,
  },
  // {
  //   path: "/investments/reports",
  //   component: FundReports,
  // },
  // {
  //   path: '/investments/brokerage',
  //   component: Brokerage,
  // },
  {
    path: "/funds/my-funds/my-fund-reports",
    component: MyFundReports,
  },
  {
    path: "/funds/my-funds/view-fund-report",
    component: ViewFundReport,
  },
  {
    path: "/funds/subscribe",
    component: Subscribe,
  },
  {
    path: "/funds/redeem",
    component: Redeem,
  },

  {
    path: "/funds/buy-order",
    component: BuyOrder,
  },
  {
    path: "/funds/internal-unit-exchange",
    component: OrderStatus,
  },
  {
    path: "/funds/sell-order",
    component: SellOrder,
  },
  {
    path: "/funds/transactions",
    component: Transactions,
  },
  {
    path: "/transfers/transfer",
    component: Transfer,
  },
  {
    path: "/transfers/beneficiaries",
    component: Beneficiaries,
  },
  {
    path: "/report/account-statement",
    component: AccountStatement,
  },
  {
    path: "/report/investment-report",
    component: InvestmentReport,
  },
  {
    path: "/settings/general-settings",
    component: GeneralSettings,
  },
  {
    path: "/settings/general-settings/edit-vat-number",
    component: VatNumber,
  },
  {
    path: "/settings/tradings-settings",
    component: TradingSettings,
  },
  {
    path: "/help/faqs",
    component: Faqs,
    isPublic: true,
  },
  {
    path: "/help/account-closure",
    component: AccountClosure,
  },
  {
    path: "/help/ticketing-history",
    component: TicketingHistory,
  },
  {
    path: "/help/contact",
    component: Contact,
  },
  {
    path: "/terms",
    component: Terms,
    isSidebar: false,
  },
  {
    path: "/information-security",
    component: InformationSecurity,
    isSidebar: false,
  },
  {
    path: "/corporate-form",
    component: CorporateForm,
    isSidebar: false,
    isPublic: true,
  },
  {
    path: "/individual-form",
    component: IndividualForm,
    isSidebar: false,
    isPublic: true,
  },
  {
    path: "*",
    component: PageNotFound,
    isPublic: true,
    isSidebar: false,
  },
  {
    path: "/forbidden",
    component: ErrorForbidden,
    isSidebar: false,
    isPublic: true,
  },
];

// languages
export const languages = {
  eng: "English",
  arb: "Arabic",
};

// font size
export const textSizes = {
  small: "small",
  medium: "medium",
  large: "large",
};

export const disconnectStates = [0, 3, 4];

// tabs menu
export const tabsMenu = (pathname) => [
  {
    id: 0,
    key: "funds",
    route: "/funds/available-funds",
    isActive: pathname?.includes("/funds"),
  },
  {
    id: 1,
    key: "my_portfolio",
    route: "/investments/overview",
    isActive: pathname?.includes("investments"),
  },
  {
    id: 3,
    key: "cash_management",
    route: "/transfers/transfer",
    isActive: pathname?.includes("transfer"),
    suspended_route: "/transfers/beneficiaries",
  },
  {
    id: 5,
    key: "settings",
    route: "/settings/general-settings",
    isActive: pathname?.includes("settings"),
  },
  // {
  //   id: 6,
  //   key: "help",
  //   route: "/help/contact",
  //   isActive: pathname?.includes("help"),
  // },
];

// tabs dropdown menus
export const investmentsMenu = (pathname) => [
  {
    id: 0,
    label: "Cash Overview",
    key: "cash_overview",
    disableIcon: icons.home,
    activeIcon: icons.homeSelected,
    isActive: pathname?.includes("overview"),
    route: "/investments/overview",
  },
  {
    id: 1,
    key: "my_investment",
    label: "My investments",
    disableIcon: icons.pieChart,
    activeIcon: icons.pieChartSelected,
    isChild: true,
    isActive: pathname?.includes("manage-investments"),
    route: "/investments/manage-investments/my-investments",
    // childs: [
    // {
    //   key: "performance",
    //   label: "Performance",
    //   isActive: pathname?.includes("performance"),
    //   route: "/investments/manage-investments/performance",
    // },
    // {
    //   key: 'allocation',
    //   label: 'Allocation',
    //   isActive: pathname?.includes('allocation'),
    //   route: '/investments/manage-investments/allocation',
    // },
    //   {
    //     key: "holdings",
    //     label: "Holdings",
    //     isActive: pathname?.includes("holdings"),
    //     route: "/investments/manage-investments/holdings",
    //   },
    // ],
  },
  // {
  //   id: 2,
  //   key: 'brokerage',
  //   label: 'Brokerage',
  //   disableIcon: icons.bag,
  //   activeIcon: icons.bagSelected,
  //   isActive: pathname?.includes('brokerage'),
  //   route: '/investments/brokerage',
  // },
  {
    id: 3,
    key: "reports",
    label: "Reports",
    disableIcon: icons.fundReports_icon,
    activeIcon: icons.fundReportsSelected_icon,
    isActive: pathname?.includes("reports"),
    route: "/investments/reports",
  },
];

export const investmentsMenuOptions = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("overview"),
    key: "overview",
    route: "/investments/overview",
  },
  {
    id: 1,
    label: getContentKey("manage_investment"),
    key: "manage_investment",
    route: "/investments/manage-investments/holdings",
    childs: [
      // {
      //   key: "performance",
      //   label: getContentKey("performance"),
      // },
      {
        key: "allocation",
        label: getContentKey("allocation"),
      },
      {
        key: "holdings",
        label: getContentKey("holdings"),
      },
    ],
  },
  // {
  //   id: 2,
  //   label: getContentKey('brokerage'),
  //   key: 'brokerage',
  //   route: '/investments/brokerage',
  // },
];

export const settingsMenu = (pathname) => [
  {
    id: 0,
    label: "General Settings",
    key: "general_settings",
    disableIcon: icons.generalSetting,
    activeIcon: icons.generalSettingSelected,
    isActive: pathname?.includes("general-settings"),
    route: "/settings/general-settings",
  },
  // {
  //   id: 1,
  //   label: 'Notification Settings',
  //   key: 'notification_settings',
  //   disableIcon: icons.bell,
  //   activeIcon: icons.selectedBell,
  //   isActive: pathname?.includes('notification-settings'),
  //   route: '/settings/notification-settings',
  // },
  // {
  //   id: 2,
  //   label: "Trading Settings",
  //   key: "trading_settings",
  //   disableIcon: icons.state,
  //   activeIcon: icons.selectedState,
  //   isActive: pathname?.includes("tradings-settings"),
  //   route: "/settings/tradings-settings",
  // },
];

export const settingsMenuOptions = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("general_settings"),
    key: "general_settings",
    route: "/settings/general-settings",
  },
  // {
  //   id: 1,
  //   label: getContentKey('notification_settings'),
  //   key: 'notification_settings',
  //   route: '/settings/notification-settings',
  // },
  // {
  //   id: 2,
  //   label: getContentKey("trading_settings"),
  //   key: "trading_settings",
  //   route: "/settings/tradings-settings",
  // },
];

export const helpMenu = (pathname) => [
  // {
  //   id: 0,
  //   label: "FAQs",
  //   key: "faqs",
  //   disableIcon: icons.comment,
  //   activeIcon: icons.selectedComment,
  //   isActive: pathname?.includes("faqs"),
  //   route: "/help/faqs",
  // },
  {
    id: 1,
    label: "Contact",
    key: "contact",
    disableIcon: icons.slip,
    activeIcon: icons.slipSelected,
    isActive: pathname?.includes("contact"),
    route: "/help/contact",
  },
];

export const helpMenuOptions = (getContentKey) => [
  // {
  //   id: 0,
  //   label: getContentKey("faqs"),
  //   key: "faqs",
  //   route: "/help/faqs",
  // },
  {
    id: 1,
    label: getContentKey("contact"),
    key: "contact",
    route: "/help/contact",
  },
];

export const reportMenu = (pathname) => [
  {
    id: 0,
    label: "Account statements",
    key: "account_statement",
    disableIcon: icons.statement,
    activeIcon: icons.selectedStatement,
    isActive: pathname?.includes("account-statement"),
    route: "/report/account-statement",
  },
  {
    id: 1,
    label: "Investment reports",
    key: "investment_report",
    disableIcon: icons.investment,
    activeIcon: icons.selectedInvestment,
    isActive: pathname?.includes("investment-report"),
    route: "/report/investment-report",
  },
];

export const reportMenuOptions = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("account_statement"),
    key: "account_statement",
    route: "/report/account-statement",
  },
  {
    id: 1,
    label: getContentKey("investment_report"),
    key: "investment_report",
    route: "/report/investment-report",
  },
];

export const fundsMenu = (pathname) => [
  {
    id: 2,
    label: "Available Funds",
    key: "available_funds",
    disableIcon: icons.subscribe,
    activeIcon: icons.subscribeSelected,
    isActive: pathname?.includes("/funds/available-funds"),
    route: "/funds/available-funds",
  },
  {
    id: 3,
    label: "my-funds",
    key: "my_funds",
    disableIcon: icons.myFund,
    activeIcon: icons.myFundSelected,
    isActive: pathname?.includes("/funds/my-funds"),
    route: "/funds/my-funds",
  },
  {
    id: 4,
    label: "internal-unit-exchange",
    key: "internal_unit_exchange",
    disableIcon: icons.internalUnitExchange,
    activeIcon: icons.internalUnitExchangeSelected,
    isActive: pathname?.includes("internal-unit-exchange"),
    route: "/funds/internal-unit-exchange",
  },
  {
    id: 5,
    label: "Transactions",
    key: "transactions",
    disableIcon: icons.transactions,
    activeIcon: icons.transactionsSelected,
    isActive: pathname?.includes("transactions"),
    route: "/funds/transactions",
  },
];

export const prodFundsMenu = (pathname) => [
  {
    id: 2,
    label: "Available Funds",
    key: "available_funds",
    disableIcon: icons.subscribe,
    activeIcon: icons.subscribeSelected,
    isActive: pathname?.includes("/funds/available-funds"),
    route: "/funds/available-funds",
  },
  {
    id: 3,
    label: "my-funds",
    key: "my_funds",
    disableIcon: icons.myFund,
    activeIcon: icons.myFundSelected,
    isActive: pathname?.includes("/funds/my-funds"),
    route: "/funds/my-funds",
  },
  {
    id: 5,
    label: "Transactions",
    key: "transactions",
    disableIcon: icons.transactions,
    activeIcon: icons.transactionsSelected,
    isActive: pathname?.includes("transactions"),
    route: "/funds/transactions",
  },
];

export const fundsMenuOptions = (getContentKey) => [
  // {
  //   id: 0,
  //   label: getContentKey('subscribe'),
  //   key: 'subscribe',
  //   route: '/funds/subscribe',
  // },
  {
    id: 1,
    label: getContentKey("my_funds"),
    key: "my_funds",
    route: "/funds/redeem",
    isDisabled: true,
  },
  {
    id: 2,
    label: "Available Funds",
    key: "available_funds",
    disableIcon: icons.subscribe,
    activeIcon: icons.subscribeSelected,
    route: "/funds/available-funds",
  },
  // {
  //   id: 2,
  //   label: getContentKey('switch'),
  //   key: 'switch',
  //   route: '/funds/switch',
  // },
  {
    id: 3,
    label: getContentKey("internal_unit_exchange"),
    key: "internal-unit-exchange",
    disableIcon: icons.internalUnitExchange,
    activeIcon: icons.internalUnitExchangeSelected,
    route: "/funds/internal-unit-exchange",
  },
  {
    id: 4,
    label: getContentKey("transactions"),
    key: "transactions",
    disableIcon: icons.slip,
    activeIcon: icons.slipSelected,
    route: "/funds/transactions",
  },
];

export const transferMenu = (pathname) => [
  {
    id: 0,
    label: "Transfer",
    key: "transfer",
    disableIcon: icons.transfer,
    activeIcon: icons.transferSelected,
    isActive:
      pathname?.includes("transfers/transfer") && !pathname?.includes("beneficiaries"),
    route: "/transfers/transfer",
    suspendedRoute: true
  },
  {
    id: 1,
    label: "Add-Top-up",
    key: "add_top_up",
    disableIcon: icons.addTopupIcon,
    activeIcon: icons.addTopupIconSelected,
    isActive: pathname?.includes("topup"),
    route: '/transfers/topup',
    suspendedRoute: true
  },
  {
    id: 2,
    label: "Beneficiaries",
    key: "beneficiaries",
    disableIcon: icons.beneficiery,
    activeIcon: icons.beneficierySelected,
    isActive: pathname?.includes("beneficiaries"),
    route: "/transfers/beneficiaries",
  },
];

export const transferMenuOptions = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("transfer"),
    key: "transfer",
    route: "/transfers/transfer",
  },
  {
    id: 1,
    label: getContentKey("beneficiaries"),
    key: "beneficiaries",
    route: "/transfers/beneficiaries",
  },
];

export const tradingMenu = (pathname) => [
  {
    id: 0,
    label: "Overview",
    key: "overview",
    disableIcon: icons.state,
    activeIcon: icons.stateSelected,
    isActive: pathname?.includes("overview"),
    route: "/trading/overview",
  },
  {
    id: 1,
    label: "Sub-accounts",
    key: "sub_accounts",
    disableIcon: icons.twoPerson,
    activeIcon: icons.twoPersonSelected,
    isActive: pathname?.includes("sub-accounts"),
    route: "/trading/sub-accounts",
  },
  {
    id: 2,
    label: "Market",
    key: "market",
    disableIcon: icons.monitorGraph,
    activeIcon: icons.monitorGraphSelected,
    isActive: pathname?.includes("market"),
    route: "/trading/market",
  },
  {
    id: 3,
    label: "Order list",
    key: "order_list",
    disableIcon: icons.ordersList,
    activeIcon: icons.orderListSelected,
    isActive: pathname?.includes("order-list"),
    route: "/trading/order-list",
  },
  {
    id: 4,
    label: "Tadawulaty",
    key: "tadawulaty",
    disableIcon: icons.letterT,
    activeIcon: icons.letterTSelected,
    isActive: pathname?.includes("tadawulaty"),
    route: "/trading/tadawulaty",
  },
];

export const tradingMenuOptions = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("overview"),
    key: "overview",
    route: "/trading/overview",
  },
  {
    id: 1,
    label: getContentKey("sub_accounts"),
    key: "sub_accounts",
    route: "/trading/sub-accounts",
  },
  {
    id: 2,
    label: getContentKey("market"),
    key: "market",
    route: "/trading/market",
  },
  {
    id: 3,
    label: getContentKey("order_list"),
    key: "order_list",
    route: "/trading/order-list",
  },
  {
    id: 4,
    label: getContentKey("tadawulaty"),
    key: "tadawulaty",
    route: "/trading/tadawulaty",
  },
];

// dropdown options
export const languageDropdown = [
  {
    languageId: 1,
    languageName: "English",
  },
  {
    languageId: 2,
    languageName: "Arabic",
  },
];

export const positionOptions = (getContentKey) => [
  {
    key: "bottom-right",
    label: getContentKey("bottom_right"),
  },
  {
    key: "bottom-left",
    label: getContentKey("bottom_left"),
  },
  {
    key: "top-right",
    label: getContentKey("top_right"),
  },
  {
    key: "top-left",
    label: getContentKey("top_left"),
  },
];

export const orderSideOptions = [
  {
    key: "buy",
    label: "Buy",
  },
  {
    key: "sell",
    label: "Sell",
  },
];

export const goodTillOptions = [
  {
    key: "day",
    label: "Day",
  },
  {
    key: "night",
    label: "Night",
  },
];

export const buyModeOptions = [
  {
    key: "limit",
    label: "Limit order",
  },
];

export const fillTermsOptions = [
  {
    key: "market-default",
    label: "Market default",
  },
];

export const sellModeOptions = [
  {
    key: "stop-market-sell",
    label: "Stop market sell",
  },
];

export const portfolioOptions = [
  {
    key: "regular-dfm",
    label: "1 - Regular DFM",
  },
];

export const cashAccountOptions = [
  {
    key: "0671127728901",
    label: "0671127728901",
  },
];

export const dropdownOptions = [
  {
    key: 0,
    label: "Option 1",
  },
  {
    key: 1,
    label: "Option 2",
  },
  {
    key: 2,
    label: "Option 3",
  },
];

export const transactionsFilterOptions = (getContentKey) => [
  {
    key: 0,
    label: getContentKey("all"),
  },
  {
    key: 1,
    label: getContentKey("subscription"),
  },
  {
    key: 2,
    label: getContentKey("redemption"),
  },
  {
    key: 3,
    label: getContentKey("switch"),
  },
];

export const monthsOptions = (getContentKey) => [
  {
    key: "01",
    label: getContentKey("jan"),
  },
  {
    key: "02",
    label: getContentKey("feb"),
  },
  {
    key: "03",
    label: getContentKey("march"),
  },
  {
    key: "04",
    label: getContentKey("april"),
  },
  {
    key: "05",
    label: getContentKey("may"),
  },
  {
    key: "06",
    label: getContentKey("june"),
  },
  {
    key: "07",
    label: getContentKey("july"),
  },
  {
    key: "08",
    label: getContentKey("aug"),
  },
  {
    key: "09",
    label: getContentKey("sep"),
  },
  {
    key: "10",
    label: getContentKey("oct"),
  },
  {
    key: "11",
    label: getContentKey("nov"),
  },
  {
    key: "12",
    label: getContentKey("dec"),
  },
];

export const years = [
  {
    year: "2025",
  },
  {
    year: "2024",
  },
  {
    year: "2023",
  },
  {
    year: "2022",
  },
  {
    year: "2021",
  },
  {
    year: "2020",
  },
  {
    year: "2019",
  },
  {
    year: "2018",
  },
  {
    year: "2017",
  },
];

export const emailOptions = [
  {
    key: 0,
    label: "Select recipient",
  },
  {
    key: 1,
    label: "John",
  },
  {
    key: 2,
    label: "David",
  },
];

export const clientDetailOptions = [
  {
    id: 0,
    label: "client_details",
  },
  {
    id: 1,
    label: "update_kyc",
  },
];

// tables data
export const overViewTableData = [
  {
    id: 0,
    col1: "",
    col2: "Balance",
    col3: "% of net assets",
  },
  {
    id: 1,
    col1: "Managed investments",
    col2: "176,865,715.45",
    col3: 95,
  },
  {
    id: 2,
    col1: "Brokerage",
    col2: "34,400.00",
    col3: 5,
  },
  {
    id: 3,
    col1: "Total",
    col2: "186,681,514.45",
    col3: "100%",
  },
];

export const brokerageHoldingsColumns = (getContentKey) => [
  {
    id: "fundName",
    label: getContentKey("current_investment"),
    dataIndex: "fundName",
    numeric: false,
    align: "left",
    width: 170,
  },
  {
    id: "quantity",
    label: getContentKey("quantity"),
    dataIndex: "quantity",
    numeric: true,
    width: 100,
  },
  {
    id: "totalCost",
    label: getContentKey("total_cost"),
    dataIndex: "totalCost",
    numeric: true,
    width: 120,
  },
  {
    id: "averageCost",
    label: getContentKey("avg_cost"),
    dataIndex: "averageCost",
    numeric: true,
    width: 140,
  },
  {
    id: "marketPrice",
    label: getContentKey("market_price"),
    dataIndex: "marketPrice",
    numeric: true,
    width: 140,
  },
  {
    id: "marketValueSar",
    label: getContentKey("market_value"),
    dataIndex: "marketValueSar",
    numeric: true,
    width: 140,
  },
  {
    id: "unrealizedGainOrLoss",
    label: getContentKey("gain_loss"),
    dataIndex: "unrealizedGainOrLoss",
    numeric: true,
    width: 200,
  },
  {
    id: "valuationDate",
    label: getContentKey("validation_date"),
    dataIndex: "valuationDate",
    numeric: true,
    width: 150,
  },
];

export const assetAllocationColumns = (getContentKey) => [
  {
    id: "assetClass",
    label: getContentKey("asset_class"),
    dataIndex: "assetClass",
    numeric: false,
    align: "left",
    width: 170,
  },
  {
    id: "marketValue",
    label: getContentKey("market_value"),
    dataIndex: "marketValue",
    numeric: true,
    width: 100,
  },
  {
    id: "percentage",
    label: getContentKey("percent_of_net_asset"),
    dataIndex: "percentage",
    numeric: true,
    width: 120,
  },
];

export const cashBalanceColumns = (getContentKey) => [
  {
    id: "fundName",
    label: getContentKey("investment_portfolio"),
    dataIndex: "fundName",
    numeric: false,
    align: "left",
    width: 170,
  },
  {
    id: "currency",
    label: getContentKey("currency"),
    dataIndex: "currency",
    numeric: false,
    width: 100,
  },
  {
    id: "value",
    label: getContentKey("value"),
    dataIndex: "value",
    numeric: true,
    width: 90,
  },
  {
    id: "valueSar",
    label: getContentKey("value_sar"),
    dataIndex: "valueSar",
    numeric: true,
    width: 140,
  },
  {
    id: "allocationPercentage",
    label: getContentKey("allocation_percentage"),
    dataIndex: "allocationPercentage",
    numeric: true,
    width: 130,
  },
];

export const transactionsColumns = (getContentKey) => [
  {
    id: "settings",
    label: <ReactSVG src={icons.settings} />,
    // label: '',
    // dataIndex: 'settings',
    numeric: false,
    children: <ReactSVG src={icons.dots} className="ms-1" />,
    width: 40,
  },
  {
    id: "order_id",
    label: getContentKey("table_id"),
    dataIndex: "typeId",
    numeric: true,
    width: 50,
  },
  {
    id: "type",
    label: getContentKey("type"),
    dataIndex: "type",
    numeric: false,
  },
  {
    id: "fund",
    label: getContentKey("fund"),
    dataIndex: "fundName",
    numeric: false,
  },
  {
    id: "amount",
    label: getContentKey("amount"),
    dataIndex: "amount",
    numeric: true,
  },
  {
    id: "date",
    label: getContentKey("date"),
    dataIndex: "date",
  },
  {
    id: "status",
    label: getContentKey("status"),
    dataIndex: "status",
  },
];

export const transactionsData = [
  {
    key: 0,
    transactionNumber: 64147714671541,
    type: "Subscription",
    fund: "Tadawul 1",
    amount: 2000,
    date: "18/06/2019",
    status: "Submitted",
  },
  {
    key: 1,
    transactionNumber: 98729371837361,
    type: "Redemption",
    fund: "Tadawul 2",
    amount: 230,
    date: "23/05/2018",
    status: "Completed",
  },
  {
    key: 2,
    transactionNumber: 51938931801018,
    type: "Switch",
    fund: "Tadawul 3",
    amount: 100,
    date: "28/04/2018",
    status: "Completed",
  },
];

export const transferColumns = (getContentKey, isArabic) => [
  {
    id: "settings",
    label: "",
    dataIndex: "settings",
    children: <ReactSVG src={icons.dots} className="ms-1" />,
    width: isArabic ? 60 : 40,
    align: "left",
  },
  // {
  //   id: 'transactionNumber',
  //   label: getContentKey('transaction_number'),
  //   dataIndex: 'transactionNumber',
  //   width: 120,
  // },
  {
    id: "date",
    label: getContentKey("transaction_date_table"),
    dataIndex: "createdDate",
    width: 120,
    isDate: true,
  },
  // {
  //   id: 'fromAccount',
  //   label: getContentKey('from_account'),
  //   dataIndex: 'fromAccount',
  // },
  {
    id: "toIban",
    label: getContentKey("to_account_table"),
    dataIndex: "iban",
    width: 190,
  },
  {
    id: "amount",
    label: getContentKey("amount"),
    dataIndex: "amount",
    numeric: true,
  },
  {
    id: "currency",
    label: getContentKey("amount_currency"),
    // dataIndex: 'currency',
    children: "SAR",
  },
  {
    id: "status",
    label: getContentKey("status"),
    dataIndex: "status",
    numeric: false,
  },
  {
    id: "comments",
    label: getContentKey("comments"),
    dataIndex: "reason",
    numeric: false,
    width: 200,
  },
];

export const transferData = [];

export const beneficiaryColumns = (getContentKey) => [
  {
    id: "close",
    label: "",
    dataIndex: "close",
    children: <ReactSVG src={icons.dots} className="w-4 flex justify-center" />,
    width: 40,
  },
  {
    id: "beneficiaryId",
    label: getContentKey("id_label"),
    dataIndex: "id",
    numeric: true,
    width: 40,
  },
  {
    id: "beneficiaryName",
    label: getContentKey("name"),
    dataIndex: "name",
    numeric: false,
  },
  {
    id: "bankName",
    label: getContentKey("bank_name"),
    dataIndex: "bankName",
    numeric: false,
  },
  {
    id: "iban",
    label: getContentKey("account_number_table"),
    dataIndex: "iban",
  },
  {
    id: "status",
    label: getContentKey("status"),
    dataIndex: "status",
    numeric: false,
  },
  {
    id: "creationDate",
    label: getContentKey("creation_date"),
    dataIndex: "createdDate",
    numeric: false,
  },
  // {
  //   id: 'issuedRequest',
  //   label: getContentKey('issued_request'),
  //   dataIndex: 'issuedRequest',
  //   numeric: false,
  // },
  // {
  //   id: 'comments',
  //   label: getContentKey('comments'),
  //   dataIndex: 'comments',
  //   numeric: false,
  // },
];

export const beneficiaryData = [
  {
    close: "",
    id: 1570,
    name: "Tharwat Investment Co",
    bankName: "Santander",
    accountNumber: "5A565500000000966860800179",
    status: "Accepted",
    creationDate: "19/09/2018",
    issuedRequest: "View request",
    comments: "Comment 1",
  },
];

export const portfolioColumns = (getContentKey, isArabic) => [
  {
    id: "close",
    // label: (
    //   <ReactSVG
    //     src={icons.settings}
    //     className={`${isArabic ? "me-1" : "ms-1"}`}
    //   />
    // ),
    label: "",
    dataIndex: "close",
    numeric: false,
    children: <ReactSVG src={icons.dots} className={`ms-1`} />,
    width: isArabic ? 60 : 35,
    align: "left",
  },
  {
    id: "name",
    label: getContentKey("symbol_name"),
    dataIndex: "name",
    numeric: false,
    width: 150,
  },
  {
    id: "marketId",
    label: getContentKey("id_label"),
    dataIndex: "marketId",
    numeric: true,
    width: 80,
  },
  {
    id: "quantity",
    label: getContentKey("quantity"),
    dataIndex: "quantity",
    numeric: true,
  },
  {
    id: "pledged",
    label: getContentKey("pledged"),
    dataIndex: "pledged",
    numeric: true,
  },
  {
    id: "available",
    label: getContentKey("available"),
    dataIndex: "available",
    numeric: false,
  },
  {
    id: "avgCost",
    label: getContentKey("avg_cost"),
    dataIndex: "avgCost",
    numeric: true,
  },
  {
    id: "cost",
    label: getContentKey("cost"),
    dataIndex: "cost",
    numeric: true,
  },
  {
    id: "outstanding_sell_units",
    label: getContentKey("sell_units"),
    dataIndex: "outstanding_sell_units",
    numeric: true,
    width: 200,
  },
  {
    id: "outstanding_buy_units",
    label: getContentKey("buy_units"),
    dataIndex: "outstanding_buy_units",
    numeric: true,
    width: 200,
  },
];

export const overviewColumns = (getContentKey) => [
  {
    id: "label",
    label: "",
    dataIndex: "label",
    width: 150,
  },
  {
    id: "balance",
    label: getContentKey("balance"),
    dataIndex: "balance",
    numeric: true,
    width: 100,
  },
  {
    id: "manage_investment",
    label: getContentKey("manage_investment"),
    dataIndex: "manage_investment",
    width: 100,
  },
];

export const portfolioData = [
  {
    close: "",
    id: 1570,
    symbol_name: "Ryad Bank",
    quantity: 3999,
    pledged: 0.0,
    available: 3979,
    avgCost: 373.87,
    cost: 1495125.53,
    outstanding_sell_units: 20,
    outstanding_buy_units: 0.0,
  },
];

export const orderBasketColumns = (getContentKey, isArabic) => [
  {
    id: "close",
    // label: <ReactSVG src={icons.settings} />,
    label: "",
    dataIndex: "close",
    children: <ReactSVG src={icons.dots} className="ms-1" />,
    width: 40,
    align: "left",
  },
  {
    id: "orderBasketNumber",
    label: getContentKey("basket_order_no"),
    dataIndex: "orderBasketNumber",
    numeric: true,
    width: 170,
  },
  {
    id: "symbol",
    label: getContentKey("symbol_id"),
    dataIndex: "symbol",
    numeric: true,
    width: 130,
    // align: 'left',
  },
  {
    id: "name",
    label: getContentKey("short_name"),
    dataIndex: "name",
    numeric: false,
    width: 190,
  },
  {
    id: "quantity",
    label: getContentKey("quantity"),
    dataIndex: "quantity",
    numeric: true,
  },
  {
    id: "triggerPrice",
    label: getContentKey("price"),
    dataIndex: "triggerPrice",
    numeric: true,
  },
  {
    id: "portfolio",
    label: getContentKey("portfolio"),
    dataIndex: "portfolio",
    numeric: false,
  },
  {
    id: "order_side",
    label: getContentKey("order_side"),
    dataIndex: "orderSide",
    numeric: false,
    width: 130,
  },
  {
    id: "order_type",
    label: getContentKey("order_type"),
    dataIndex: "orderType",
    numeric: false,
    width: 130,
  },
  {
    id: "market",
    label: getContentKey("market"),
    dataIndex: "market",
    numeric: false,
  },
];

export const orderBasketData = [
  {
    close: "",
    order_no: 2,
    id: 1570,
    symbol_short_name: 3999,
    Symbol_name: 0.0,
    quantity: 3979,
    price: 373.87,
    portfolio: 1495125.53,
    order_side: 20,
    order_type: 0.0,
    market: 0.0,
  },
];

export const watchListColumns = (getContentKey) => [
  {
    id: "setting",
    // label: <ReactSVG src={icons.settings} className="ms-1 " />,
    label: "",
    dataIndex: "setting",
    numeric: false,
    children: <ReactSVG src={icons.dots} className="ms-1" />,
    align: "left",
    width: 60,
  },
  {
    id: "ShortSymbolName",
    label: getContentKey("symbol_name"),
    dataIndex: "ShortSymbolName",
    numeric: false,
    width: 150,
  },
  {
    id: "bidPrice",
    label: getContentKey("bid_price"),
    dataIndex: "bbp",
    numeric: true,
    width: 80,
  },
  {
    id: "id",
    label: getContentKey("id_label"),
    dataIndex: "sym",
    numeric: true,
    width: 80,
  },
  {
    id: "offerPrice",
    label: getContentKey("offer_price"),
    dataIndex: "bap",
    numeric: true,
    width: 80,
  },
  {
    id: "lastPrice",
    label: getContentKey("last_price"),
    dataIndex: "ltp",
    numeric: true,
    width: 80,
  },
  {
    id: "chg",
    label: getContentKey("chg"),
    dataIndex: "chg",
    numeric: true,
    width: 80,
  },
  {
    id: "offerQty",
    label: getContentKey("offer_qty"),
    dataIndex: "baq",
    numeric: true,
    width: 80,
  },
  {
    id: "chgPercent",
    label: getContentKey("chg_percent"),
    dataIndex: "pctChg",
    numeric: true,
    width: 100,
  },
  {
    id: "prevClose",
    label: getContentKey("prev_close"),
    dataIndex: "prvCls",
    numeric: true,
    width: 80,
  },
  {
    id: "noOfTrades",
    label: getContentKey("no_trades"),
    dataIndex: "trades",
    numeric: true,
    width: 90,
  },
  {
    id: "lastVolumn",
    label: getContentKey("last_volume"),
    dataIndex: "vol",
    numeric: true,
    width: 100,
  },
];

export const cashAccountColumns = (getContentKey) => [
  {
    id: "iban",
    label: getContentKey("iban"),
    dataIndex: "accountInformation",
    dataIndex2: "cashAccount",
    align: "left",
    width: 200,
    isIban: true,
  },
  {
    id: "currency",
    label: getContentKey("currency"),
    dataIndex: "accountInformation",
    dataIndex2: "currency",
    width: 170,
  },
  {
    id: "value",
    label: getContentKey("value"),
    dataIndex: "total",
    numeric: true,
    width: 140,
  },
  {
    id: "value_in_sar",
    label: getContentKey("value_in_sar"),
    dataIndex: "total",
    numeric: true,
    width: 140,
  },
  {
    id: "available_balance",
    label: getContentKey("available_balance"),
    dataIndex: "availableCash",
    numeric: true,
    width: 140,
  },
  {
    id: "blocked_balance",
    label: getContentKey("blocked_balance"),
    dataIndex: "blockedCash",
    numeric: true,
    width: 140,
  },
];

export const watchListData = [
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
  {
    symbolName: "Ryad Bank",
    bidPrice: 0.0,
    id: 1010,
    offerPrice: 0.0,
    lastPrice: 0.0,
    chg: 0.0,
    offerQty: 0,
    chgPercent: 0.0,
    prevClose: 0.0,
    noOfTrades: 0,
    lastVolumn: 0,
  },
];

export const stockPositionColumns = (getContentKey) => [
  {
    id: "close",
    // label: <ReactSVG src={icons.settings} className="w-2 h-2" />,
    label: "",
    dataIndex: "close",
    children: <ReactSVG src={icons.dots} className="ms-1" />,
    width: 50,
    align: "left",
  },
  {
    id: "name",
    label: getContentKey("symbol_name"),
    dataIndex: "name",
    numeric: false,
  },
  {
    id: "marketId",
    label: getContentKey("id_label"),
    dataIndex: "marketId",
    numeric: false,
  },
  {
    id: "quantity",
    label: getContentKey("quantity"),
    dataIndex: "quantity",
    numeric: true,
  },
  {
    id: "pledged",
    label: getContentKey("pledged"),
    dataIndex: "pledged",
    numeric: true,
  },
  {
    id: "available",
    label: getContentKey("available"),
    dataIndex: "available",
    numeric: true,
  },
  {
    id: "averageCost",
    label: getContentKey("avg_cost"),
    dataIndex: "averageCost",
    numeric: true,
  },
  {
    id: "marketValue",
    label: getContentKey("cost"),
    dataIndex: "marketValue",
    numeric: true,
  },
  {
    id: "outstandingSellUnits",
    label: getContentKey("sell_units"),
    dataIndex: "outstandingSellUnits",
    numeric: true,
  },
  {
    id: "outstandingBuyUnits",
    label: getContentKey("buy_units"),
    dataIndex: "outstandingBuyUnits",
    numeric: true,
  },
  {
    id: "marketValue2",
    label: getContentKey("market_value"),
    dataIndex: "marketValue",
    numeric: true,
  },
  {
    id: "evaluationPrice",
    label: getContentKey("evaluation_price"),
    dataIndex: "evaluationPrice",
    numeric: true,
  },
  {
    id: "unrlzd",
    label: getContentKey("unrlzd"),
    dataIndex: "unrlzd",
    numeric: true,
  },
  {
    id: "currency",
    label: getContentKey("currency"),
    dataIndex: "currency",
    numeric: false,
  },
];

export const stockPositionData = [
  {
    close: "",
    symbolName: "SABIC",
    id: 1570,
    quantity: 3999,
    pledged: 0.0,
    available: 3979,
    avgCost: 373.87,
    cost: 1495125.53,
    outstandingSellUnits: 20,
    outstandingBuyUnits: 422,
    marketValue: 483879.0,
    evaluationPrice: 121.0,
    unrlzd: -1011246.53,
    currency: "SAR",
  },
];

export const orderDetailColumns = (getContentKey) => [
  {
    id: "close",
    // label: <ReactSVG src={icons.settings} className="w-2 h-2" />,
    label: "",
    dataIndex: "close",
    numeric: false,
    children: <ReactSVG src={icons.dots} className="ms-2" />,
    width: 50,
    align: "left",
  },
  {
    id: "orderNo",
    label: getContentKey("basket_order_no"),
    dataIndex: "orderNo",
    numeric: false,
  },
  {
    id: "symbol",
    label: getContentKey("symbol_id"),
    dataIndex: "symbol",
    numeric: false,
  },
  {
    id: "symbolName",
    label: getContentKey("symbol_name"),
    dataIndex: "symbolName",
    numeric: false,
  },
  {
    id: "orderSide",
    label: getContentKey("side"),
    dataIndex: "orderSide",
    numeric: false,
  },
  {
    id: "quantity",
    label: getContentKey("quantity"),
    dataIndex: "quantity",
    numeric: true,
  },
  {
    id: "price",
    label: getContentKey("price"),
    dataIndex: "price",
    numeric: true,
  },
  {
    id: "orderType",
    label: getContentKey("order_type"),
    dataIndex: "orderType",
    numeric: false,
  },
  {
    id: "orderStatus",
    label: getContentKey("order_status"),
    dataIndex: "orderStatus",
    numeric: false,
  },
  {
    id: "portfolioCode",
    label: getContentKey("portfolio"),
    dataIndex: "portfolioCode",
    numeric: false,
  },
  {
    id: "currency",
    label: getContentKey("currency"),
    dataIndex: "currency",
    numeric: false,
  },
  {
    id: "createdDate",
    label: getContentKey("created_date"),
    dataIndex: "createdDate",
    numeric: false,
  },
  {
    id: "expiryDate",
    label: getContentKey("expired_date"),
    dataIndex: "expiryDate",
    numeric: false,
  },
];

export const orderDetailData = [
  {
    close: "",
    orderNo: 8000866041,
    id: 1020,
    symbolName: "Al-Jazira Bank",
    side: "Buy",
    quantity: 12,
    price: 16.5,
    orderType: "Limit order (Buy)",
    orderStatus: "Queued",
    portfolio: "1 - TADAWADUL1",
    currency: "SAR",
    createdDate: "14/09/2020",
    expiredDate: "14/09/2020",
  },
  {
    close: "",
    orderNo: 8000866041,
    id: 1020,
    symbolName: "Al-Jazira Bank",
    side: "Sell",
    quantity: 12,
    price: 16.5,
    orderType: "Limit order (Buy)",
    orderStatus: "Queued",
    portfolio: "1 - TADAWADUL1",
    currency: "SAR",
    createdDate: "14/09/2020",
    expiredDate: "14/09/2020",
  },
  {
    close: "",
    orderNo: 8000866041,
    id: 1020,
    symbolName: "Al-Jazira Bank",
    side: "Buy",
    quantity: 12,
    price: 16.5,
    orderType: "Limit order (Buy)",
    orderStatus: "Queued",
    portfolio: "1 - TADAWADUL1",
    currency: "SAR",
    createdDate: "14/09/2020",
    expiredDate: "14/09/2020",
  },
  {
    close: "",
    orderNo: 8000866041,
    id: 1020,
    symbolName: "Al-Jazira Bank",
    side: "Sell",
    quantity: 12,
    price: 16.5,
    orderType: "Limit order (Buy)",
    orderStatus: "Queued",
    portfolio: "1 - TADAWADUL1",
    currency: "SAR",
    createdDate: "14/09/2020",
    expiredDate: "14/09/2020",
  },
  {
    close: "",
    orderNo: 8000866041,
    id: 1020,
    symbolName: "Al-Jazira Bank",
    side: "Buy",
    quantity: 12,
    price: 16.5,
    orderType: "Limit order (Buy)",
    orderStatus: "Queued",
    portfolio: "1 - TADAWADUL1",
    currency: "SAR",
    createdDate: "14/09/2020",
    expiredDate: "14/09/2020",
  },
  {
    close: "",
    orderNo: 8000866041,
    id: 1020,
    symbolName: "Al-Jazira Bank",
    side: "Buy",
    quantity: 12,
    price: 16.5,
    orderType: "Limit order (Buy)",
    orderStatus: "Queued",
    portfolio: "1 - TADAWADUL1",
    currency: "SAR",
    createdDate: "14/09/2020",
    expiredDate: "14/09/2020",
  },
];

export const gainLossColumns = (getContentKey) => [
  {
    id: "close",
    dataIndex: "close",
    // label: <ReactSVG src={icons.settings} className="w-2 h-2" />,
    label: "",
    numeric: false,
    children: <ReactSVG src={icons.dots} className="ms-2" />,
    width: 50,
    align: "left",
  },
  {
    id: "name",
    dataIndex: "ShortSymbolName",
    label: getContentKey("symbol_name"),
    numeric: false,
  },
  {
    id: "clientId",
    dataIndex: "clientId",
    label: getContentKey("id_label"),
    numeric: true,
  },
  {
    id: "lastPrice",
    dataIndex: "ltp",
    label: getContentKey("last_price"),
    numeric: true,
  },
  {
    id: "changeDirectionIcon",
    dataIndex: "pctChg",
    label: getContentKey("chg_dir"),
    numeric: false,
    isGainLoss: true,
  },
  {
    id: "changeDirection",
    dataIndex: "chg",
    label: getContentKey("chg"),
    numeric: true,
  },
  {
    id: "changePercent",
    dataIndex: "pctChg",
    label: getContentKey("chg_percent"),
    numeric: true,
  },
  {
    id: "totalVolume",
    dataIndex: "vol",
    label: getContentKey("t_volume"),
    numeric: true,
  },
  {
    id: "turnover",
    dataIndex: "tovr",
    label: getContentKey("turnover"),
    numeric: true,
  },
];

export const mostActiveSymbolColumns = (getContentKey) => [
  {
    id: "close",
    // label: <ReactSVG src={icons.settings} className="w-2 h-2" />,
    label: "",
    dataIndex: "close",
    children: <ReactSVG src={icons.dots} className="ms-2" />,
    width: 40,
    align: "left",
  },
  {
    id: "name",
    label: getContentKey("symbol_name"),
    dataIndex: "ShortSymbolName",
    numeric: false,
    width: 120,
  },
  {
    id: "id",
    label: getContentKey("id_label"),
    dataIndex: "sym",
    numeric: true,
  },
  {
    id: "lastPrice",
    label: getContentKey("last_price"),
    dataIndex: "ltp",
    numeric: true,
  },
  {
    id: "chgDir",
    label: getContentKey("chg_dir"),
    dataIndex: "pctChg",
    numeric: true,
    isGainLoss: true,
  },
  {
    id: "changeDirections",
    label: getContentKey("chg"),
    dataIndex: "chg",
    numeric: true,
  },
  {
    id: "changeDirections",
    label: getContentKey("chg_percent"),
    dataIndex: "pctChg",
    numeric: true,
  },
  {
    id: "totalVolume",
    label: getContentKey("t_volume"),
    dataIndex: "vol",
    numeric: true,
  },
  {
    id: "turnover",
    label: getContentKey("turnover"),
    dataIndex: "tovr",
    numeric: true,
  },
];

export const gainLossData = [
  {
    close: "",
    name: "Al Sorayal Group",
    id: 2010,
    lastPrice: 14.5,
    chg: 0.66,
    chgPercent: 0,
    TVolumn: 0,
    turnover: 0,
  },
];

export const transactionColumns = (getContentKey) => [
  {
    // label: () => <ReactSVG src={icons.settings} />,
    label: "",
    dataIndex: "close",
    key: "close",
    width: 30,
    children: <ReactSVG src={icons.dots} className="ms-2" />,
  },
  {
    id: "no",
    label: getContentKey("no"),
    dataIndex: "no",
    numeric: false,
    width: 40,
  },
  {
    id: "type",
    label: getContentKey("type"),
    dataIndex: "type",
    width: 70,
  },
  {
    id: "qty",
    label: getContentKey("qty"),
    dataIndex: "qty",
    width: 70,
  },
  {
    id: "price",
    label: getContentKey("price"),
    dataIndex: "price",
    width: 70,
  },
  {
    id: "fees",
    label: getContentKey("fees"),
    dataIndex: "fees",
    width: 70,
  },
  {
    id: "tradingAmt",
    label: getContentKey("trading_amt"),
    dataIndex: "tradingAmt",
    width: 110,
  },
  {
    id: "orderAmt",
    label: getContentKey("order_amt"),
    dataIndex: "orderAmt",
    width: 100,
  },
  {
    id: "avgPrice",
    label: getContentKey("avg_price"),
    dataIndex: "avgPrice",
    width: 100,
  },
  {
    id: "gainLoss",
    label: getContentKey("gain_loss"),
    dataIndex: "gainLoss",
    width: 100,
  },
  {
    id: "status",
    label: getContentKey("status"),
    dataIndex: "status",
    width: 80,
  },
  {
    id: "transDate",
    label: getContentKey("trans_date"),
    dataIndex: "transDate",
    width: 100,
  },
  {
    id: "deliveryChannel",
    label: getContentKey("delivery_channel"),
    dataIndex: "deliveryChannel",
    width: 100,
  },
  {
    id: "modifiedBy",
    label: getContentKey("modified_by"),
    dataIndex: "modifiedBy",
    width: 120,
  },
];

export const transactionData = [
  {
    close: "",
    no: 1,
    type: "New",
    qty: 12,
    price: 16.5,
    fees: 0.2,
    tradingAmt: 198.0,
    orderAmt: 198.21,
    avgPrice: "N/A",
    gainLoss: "198.21",
    status: "Active",
    transDate: "14/09/2020 14:30:35",
    deliveryChannel: "Etrade plus",
    modifiedBy: "ETRADEP001",
  },
];

export const holdingsColumns = (getContentKey) => [
  {
    label: getContentKey("holdings"),
    dataIndex: "name",
    key: "name",
    numeric: false,
    align: "left",
    width: 200,
  },
  {
    label: getContentKey("invested_capital"),
    dataIndex: "investedCapital",
    key: "investedCapital",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("capital_distributions"),
    dataIndex: "capitalDistribution",
    key: "capitalDistributions",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("net_invested_capital"),
    dataIndex: "netInvestedCapital",
    key: "netInvestedCapital",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("dividend_distributions"),
    dataIndex: "dividendDistribution",
    key: "dividendDistributions",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("capital_gains_distributions"),
    dataIndex: "capitalGainDistribution",
    key: "capitalGainsDistributions",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("market_value"),
    dataIndex: "marketValue",
    key: "marketValue",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("total_proceeds"),
    dataIndex: "totalProceeds",
    key: "totalProceeds",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("realized_gains"),
    dataIndex: "realizedGain",
    key: "realizedGains",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("unrealized_gains"),
    dataIndex: "unRealizedGain",
    key: "unrealizedGains",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("net_gains"),
    dataIndex: "netGain",
    key: "netGains",
    numeric: true,
    width: 130,
  },
  {
    label: getContentKey("number_of_unit"),
    dataIndex: "numberOfUnit",
    key: "numberOfUnit",
    // numeric: true,
    width: 130,
  },
  {
    label: getContentKey("cost_per_unit"),
    dataIndex: "costPerUnit",
    key: "costPerUnit",
    // numeric: true,
    width: 130,
  },
];

export const holdingsData = [
  {
    holdings: "SAR cash account",
    investedCapital: "5,988,855.29",
    capitalDistributions: "-",
    netInvestedCapital: "5,988,855.29",
    dividendDistributions: "-",
    capitalGainsDistributions: "-",
    marketValue: "5,988,855.29",
    totalProceeds: "-",
    realizedGains: "-",
    unrealizedGains: "686,579.26",
    total: "",
  },
];

// trading data

export const priceSpectrum = [
  {
    bid: "90 (1)",
    price: 8.4,
    offer: "90 (1)",
    bidPercentage: 10,
    offerPercentage: 0,
  },
  {
    bid: "50 (1)",
    price: 8.35,
    offer: "50 (1)",
    bidPercentage: 10,
    offerPercentage: 40,
  },
  {
    bid: "2,000 (1)",
    price: 8.33,
    offer: "2,000 (1)",
    bidPercentage: 0,
    offerPercentage: 0,
  },
  {
    bid: "56 (1)",
    price: 8.31,
    offer: "56 (1)",
    bidPercentage: 5,
    offerPercentage: 15,
  },
  {
    bid: "21,090 (3)",
    price: 8.3,
    offer: "21,090 (3)",
    bidPercentage: 30,
    offerPercentage: 20,
  },
  {
    bid: "25 (1)",
    price: 8.28,
    offer: "25 (1)",
    bidPercentage: 18,
    offerPercentage: 38,
  },
  {
    bid: "319 (3)",
    price: 8.25,
    offer: "319 (3)",
    bidPercentage: 60,
    offerPercentage: 20,
  },
  {
    bid: "26,695 (4)",
    price: 8.2,
    offer: "26,695 (4)",
    bidPercentage: 8,
    offerPercentage: 70,
  },
  {
    bid: "56 (1)",
    price: 8.18,
    offer: "56 (1)",
    bidPercentage: 35,
    offerPercentage: 10,
  },
];

export const indicesData = [
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: true,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: true,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: false,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: true,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: true,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: false,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: true,
    percent: "-135.63 (-1.77%)",
  },
  {
    name: "Tasi",
    desc: "Tadawul All Shares Index",
    price: 7526.54,
    isDown: true,
    percent: "-135.63 (-1.77%)",
  },
];

export const outstandingOrders = [
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Buy",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Buy",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Sell",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Buy",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Buy",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Buy",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Sell",
    email: "2999@458.00",
    status: "Queued",
  },
  {
    id: 866027,
    orderNo: 1020,
    bank: "Al-Jazira Bank",
    type: "Buy",
    email: "2999@458.00",
    status: "Queued",
  },
];

// tabs data

export const orderDetailsTabs = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("all"),
  },
  {
    id: 1,
    label: getContentKey("outstanding"),
  },
  {
    id: 2,
    label: getContentKey("filled"),
  },
  {
    id: 3,
    label: getContentKey("cancelled"),
  },
];

export const gainLossTabs = (getContentKey) => [
  {
    id: 0,
    label: getContentKey("gainers"),
  },
  {
    id: 1,
    label: getContentKey("losers"),
  },
];

export const activeSymbolsTabs = (getContentKey) => [
  {
    id: 1,
    name: getContentKey("value"),
    type: "6",
  },
  {
    id: 2,
    name: getContentKey("volume"),
    type: "4",
  },
];

// extra data

export const chartDurationLabel = [
  {
    key: "1d",
    label: "1D",
  },
  {
    key: "1w",
    label: "1W",
  },
  {
    key: "1m",
    label: "1M",
  },
  {
    key: "6m",
    label: "6M",
  },
  {
    key: "1y",
    label: "1Y",
  },
  {
    key: "5y",
    label: "5Y",
  },
];

export const allocationData = [
  {
    class: "Cash",
    value: "5,988,855.29",
    assetPercent: "3.39",
  },
  {
    class: "Money markets",
    value: "5,988,855.29",
    assetPercent: "3.39",
  },
  {
    class: "Fixed income",
    value: "5,988,855.29",
    assetPercent: "3.39",
  },
  {
    class: "Public equity",
    value: "5,988,855.29",
    assetPercent: "3.39",
  },
  {
    class: "Real estate",
    value: "13,664,724.00",
    assetPercent: "7.23",
  },
  {
    class: "Private equity",
    value: "62,334,725.09",
    assetPercent: "3.39",
  },
  {
    class: "Leasing",
    value: "-",
    assetPercent: "-",
  },
];

// chart colors

export const graph_colors = [
  "#00205A",
  "#657CDF",
  "#D15F40",
  "#E59F2A",
  "#878378",
  "#8F7747",
  "#B4A03A",
  "#F3F1F1",
  "#6A8A65",
  "#CB3D47",
  "#D7D1CF",
  "#355F9F",
  "#BFD4FD",
];

export const quantityOptions = [
  {
    method: "add",
    value: +10,
  },
  {
    method: "add",
    value: +100,
  },
  {
    method: "add",
    value: +1000,
  },
  {
    method: "add",
    value: +10000,
  },
  {
    method: "subtract",
    value: -10,
  },
  {
    method: "subtract",
    value: -100,
  },
  {
    method: "subtract",
    value: -1000,
  },
  {
    method: "subtract",
    value: -10000,
  },
];

export const termsAndConditions = {
  heading: "Terms and Conditions",
  download: "Download PDF",
  description:
    "These terms and conditions (“Terms and Conditions”) pertain to the Client Portal (“System”) offered by Tharwat Investment Company (“Tharwat”). By accessing the System, you agree to be bound by the Terms and Conditions. If you do not agree, please do not access this System.",
  content: [
    {
      id: 0,
      title: "a. Information",
      content: `The information contained on the System is for information purposes only. Tharwat does not hold itself out as providing legal, financial or other advice via the System.`,
    },
    {
      id: 1,
      title: "b. Products",
      content: `All products and services provided are subject to the terms and conditions and disclaimers of the applicable agreement governing their supply and use. Where products’ terms and conditions conflict with these Terms and Conditions, the product terms and conditions shall prevail.`,
    },
    {
      id: 2,
      title: "c. Changes",
      content: `The information, material and content provided in the pages of the System may be changed at any time without notice. Changes may be made by us to these Terms and Conditions, including its privacy provisions, any time without notice to you by updating the posting of the Terms and Conditions.`,
    },
    {
      id: 3,
      title: "d. Privacy",
      content: `We are committed to protecting your privacy. All information gathered from you in connection with your use of the System will be maintained in accordance with the applicable privacy policies disclosed for the System. We safeguard information we receive online from visitors who interact with our System. We maintain physical, electronic and procedural safeguards to guard your information. Unfortunately, no data transmission over the Internet can be guaranteed as totally secure. 
      
      Once Tharwat receives your information, Tharwat will take all reasonable steps to protect the information it holds in its own systems.
  
      We will not collect any information about you except where you knowingly provide it to us through our System. The information we collect about you will depend on how you use the services offered by the System.
  
      Your personal information is not shared with or sold to third parties for their independent marketing purposes.
  
      We will not reveal your personal information to any external organization unless we have your authority or by law or the order of competent authority.
  
      There may be specific and additional privacy provisions, which apply to certain sections of our services provided to you, which will operate in addition to the provisions of these Terms and Conditions. In the event of any inconsistency between the Terms and Conditions and those other specific and additional provisions, the specific and additional provisions will prevail.`,
    },
    {
      id: 4,
      title: "e. No offer",
      content: `Information or opinions provided by us or through a third party on the System should not be used for investment advice and do not constitute an offer to sell or solicitation of an offer to buy any securities or financial instruments or any advice or recommendation with respect to such securities or other financial instruments or investments. When making a decision about your investments, you should seek the advice of a professional financial adviser.`,
    },
    {
      id: 5,
      title: "f. No warranties",
      content: `The contents of the System are distributed to you without any warranty of any kind. We and the third party technology providers disclaim any and all warranties. Information on the System is provided on an "as is" and "as available" basis, and to the fullest extent permitted by law we do not give or make any warranty or representation of any kind, whether express. Your use of the System is at your sole risk.
  
      We do not warrant the accuracy, adequacy, completeness or timeliness of the information, material, products and services or the error-free use of the system.
  
      We do not represent or warrant that the System will be available or that it will meet your requirements, that access will be uninterrupted, that there will be no delays, failures, errors or omissions or loss of transmitted information, that no viruses or other contaminating or destructive properties will be transmitted or that no damage will occur to your computer system. You have sole responsibility for the adequate protection and backup of data and/or equipment and for undertaking reasonable and appropriate precautions to scan for computer viruses or other destructive properties.
  
      We make no representations or warranties regarding the accuracy, functionality or performance of any third-party software that may be used in connection with the System.`,
    },
    {
      id: 6,
      title: "g. Limitation of liability",
      content: `In no event shall we be liable for any damages, losses or liabilities including without limitation, direct or indirect, special, incidental, consequential damages, losses or liabilities, in connection with your use of the System or your reliance on or use or inability to use the information, materials, products and services on the system, or in connection with any failure of performance, error, omission, interruption, defect, delay in operation or transmission, computer virus or line or system failure, even if you advise us of the possibility of such damages, losses or expenses.`,
    },
    {
      id: 7,
      title: "h. Trademarks and copyright",
      content: `This System includes material, trademarks, logos, slogans and products. We do not grant you any license to use them whether they belong to Tharwat or any third-party intellectual property rights. Tharwat and its logo is registered in the Kingdom of Saudi Arabia. You are prohibited to copy or use Tharwat logo or any service products or any third-party products without the prior written permission of the legal owner.`,
    },
    {
      id: 8,
      title: "i. Unlawful use",
      content: `You are prohibited to use the System for any purpose which is unlawful, abusive, libelous, obscene or threatening.`,
    },
  ],
};

export const termsAndConditionsArabic = {
  heading: "الشروط والأحكام",
  download: "تحميل قوات الدفاع الشعبي",
  description: `ُ هذه الشروط واألحكام )"الشروط واألحكام"( تتصل ببوابة العمالء )"النظام"( المتاحة من قبل شركة ثروات لالستثمار )"ثروات"(. بالدخول إلى النظام، فإنكم توافقون7 على االلتزام بالشروط واألحكام. وفي حال عدم موافقتكم عليها فيرجى منكم عدم الدخول7 إلى النظام. `,
  content: [
    {
      id: 0,
      title: "المعلومات",
      content: `إن المعلومات الموجودة بالنظام هي لأغراض العلم فقط. كما أن ثروات لا تقدم المشورة القانونية أو المالية أو أي مشورة أخرى عبر هذا النظام.`,
    },
    {
      id: 1,
      title: "المنتجات",
      content: `تخضع كافة المنتجات والخدمات المقدمة للشروط والأحكام والتنازلات المتعلقة بالاتفاقيات النافذة التي تحكم تقديم واستخدام هذه المنتجات والخدمات. وفي حال تعارض شروط وأحكام المنتجات مع هذه الشروط والأحكام، فإن شروط وأحكام المنتجات هي التي يُعتد بها.`,
    },
    {
      id: 2,
      title: "التغييرات",
      content: `قد يتم تغيير الشروط والمواد والمحتويات الواردة في صفحات النظام في أي وقت دون إشعاركم. كما قد يتم إجراء تغييرات على هذه الشروط والأحكام، بما في ذلك أحكام الخصوصية، من قبلنا في أي وقت دون إخطاركم، وذلك عن طريق إجراء تحديث للشروط والأحكام.`,
    },
    {
      id: 3,
      title: "الخصوصية",
      content: `نلتزم بحماية خصوصيتكم، ومن ثم، فسيتم الاحتفاظ بكافة المعلومات التي نجمعها منكم فيما يتصل باستخدامكم للنظام، وفق سياسات الخصوصية المنطبقة والمُعلن عنها للنظام.
  
      نلتزم بحماية المعلومات التي نحصل عليها عبر الإنترنت من الزوار الذين يتفاعلون مع نظامنا، وذلك باتخاذ إجراءات فعلية وإلكترونية وإجرائية لحماية معلوماتكم. غير أنه لا يُمكن ضمان نقل البيانات عبر الإنترنت بشكلٍ آمن بالكامل.
  
      ومتى استلمت ثروات معلوماتكم، فسوف تتخذ كافة الخطوات المعقولة لحماية المعلومات التي تحتفظ بها على أنظمتها.
  
      لن نجمع أية معلومات عنكم إلا بحال قمتم بتزويدنا بها عبر النظام. وسوف تعتمد المعلومات التي نجمعها عنكم على كيفية استخدامكم للخدمات المقدمة عبر النظام.
  
      هذا ولن تتم مشاركة أو بيع معلوماتكم الشخصية لأي أطراف ثالثة لأغراض تسويقية.
  
      كما أننا لن نكشف عن معلوماتكم الشخصية إلى أي مؤسسة خارجية إلا بحال سمحتم لنا بذلك، أو بحال استوجب ذلك قانونا، أو في حال صدور أمر بذلك من سلطة مُخوّلة.
  
      قد تنطبق أحكام خصوصية محددة وإضافية على أجزاء من خدماتنا المقدمة لكم، والتي يتم العمل بموجبها إضافة إلى أحكام هذه الشروط. وبحال وجود تباين بين الأحكام والشروط والأحكام المحددة أو الإضافية الأخرى، فسوف يُعتَد بالأحكام المحددة والإضافية.`,
    },
    {
      id: 4,
      title: "لا عروض",
      content: `يجب عدم استخدام المعلومات أو الآراء المقدمة منا أو من أي طرف آخر على النظام كاستشارة استثمارية. كما أنها لا تشكل عرضا للبيع أو استقطابا لعرض شراء أية أوراق أو سندات مالية أو أي استشارة أو توصية فيما يتعلق بهذه الأوراق أو السندات المالية الأخرى أو الاستثمارات. ويجب عليكم عند اتخاذ قراراتكم بخصوص الاستثمار، طلب المشورة من مستشار مالي.`,
    },
    {
      id: 5,
      title: "لا ضمانات",
      content: `إن محتويات النظام مقدمة إليكم بدون أي ضمان من أي نوع كان، وإننا والطرف الآخر من مزودي التكنولوجيا نُخلي مسؤوليتنا عن أية ضمانات. كما أن المعلومات الواردة في النظام مقدمة على أساس "كما هي عليه" أو "كما هي متوفرة"، وأننا وللحد الأقصى الذي يسمح به القانون لا نعطي أو نقدم أي ضمانات أو تعهدات من أي نوع، سواء بصورة صريحة أو ضمنية فيما يتعلق بهذه المعلومات. ويكون استخدامكم للنظام على مسؤوليتكم الخاصة.
  
      إننا لا نضمن دقة أو كفاية أو اكتمال أو مدى حداثة أو ملاءمة توقيت المعلومات والمواد والمنتجات والخدمات أو الاستخدام الخالي من الأخطاء للنظام.
  
      كما أننا لا نتعهد أو نضمن بأن النظام سيكون متاحاً، أو أنه سيكون مستوفياً لمتطلباتكم، أو أن الدخول لن يتم قطعه، أو أنه لن يكون هناك تأخير أو إخفاق أو أخطاء أو سهو أو فقدان للمواد المنقولة، أو أنه لن يتم نقل الفيروسات أو المواد الملوثة أو المدمرة الأخرى، أو أنه لن يحدث ضرر للأنظمة الخاصة بكم. كما أنكم مسؤولون وحدكم عن الحماية الكافية والمساندة للبيانات و/أو المعدات، واتخاذ الاحتياطات المعقولة والمناسبة لإجراء عمليات المسح لفيروسات الكمبيوتر والمواد المدمرة الأخرى.
  
      لن نقدم أية بيانات أو ضمانات فيما يتعلق بدقة أو وظيفة أو أداء أي برنامج تابع لطرف آخر قد يتم استخدامه فيما يتعلق بالنظام.`,
    },
    {
      id: 6,
      title: "حدود المسؤولية",
      content: `لن نكون تحت أي ظرف من الظروف مسؤولين عن أية أضرار أو خسائر أو التزامات، بما في ذلك على سبيل الذكر لا الحصر، الأضرار أو الخسائر أو الالتزامات المباشرة وغير المباشرة أو الخاصة أو العرضية أو الناشئة فيما يتعلق باستخدامكم للنظام، أو اعتمادكم على أو استخدامكم أو عدم إمكانية استخدامكم للمعلومات والمواد والمنتجات والخدمات المتوفرة على النظام، أو فيما يتعلق بأي فشل في الأداء أو خطأ أو سهو أو انقطاع أو تعطل أو تأخر في التشغيل أو البث أو بسبب فيروسات الكمبيوتر أو تعطل الخطوط أو الأنظمة، حتى ولو تم إبلاغنا من قبلكم باحتمال حصول تلك الأضرار أو الخسائر أو المصاريف.`,
    },
    {
      id: 7,
      title: "العلامات التجارية وحقوق الطبع",
      content: `يشتمل هذا النظام على مواد وعلامات تجارية وشعارات ومنتجات. إننا لا نمنحكم ترخيصا لاستخدام تلك المواد والعلامات التجارية والشعارات والمنتجات. ونشير إلى أن ثروات وشعارها مسجلان بالمملكة العربية السعودية ويحظر عليكم نسخ أو استخدام شعار ثروات أو أي من منتجاتها أو خدماتها أو منتجات أو خدمات أي طرف آخر دون إذن كتابي مسبق من المالك القانوني.`,
    },
    {
      id: 8,
      title: "يالاستخدام غير القانوني",
      content: `يحظر عليكم استخدام النظام لأي غرض غير قانوني أو ضار أو تشهيري أو فاحش أو تهديدي.`,
    },
  ],
};

export const informationSecurity = {
  heading: "Information Security",
  download: "Download PDF",
  content: [
    {
      id: 0,
      title: "a. Introduction",
      content: `Tharwat Investment Company (“Tharwat”) is pleased to offer electronic reporting and trading services through its Client Portal (“System”). Delivering these services requires a solid security framework that protects you and our institution's data from outside intrusion. We are committed to working with our technology partners to produce the safest operating environment possible for our clients and users. The information below summarizes our security framework, which incorporates the latest proven technology and also summarizes your responsibilities as a user of the System with regard to security. There are several levels of security within our security framework.`,
    },
    {
      id: 1,
      title: "b. Login Password",
      content: `After you register with Tharwat to use the System, you will receive your username and password via SMS and email. The first time you login with the new password, the System will ask you to change it.

      If you enter the wrong password, you will get locked out after three unsuccessful failures. To unlock your account, you should contact Tharwat investment. In case you forgot your password, you can easily reset password by clicking on the “Forgot your password?” link on the Login page to receive a new password via email.

      Please note that whenever you login successfully in to your account, the System will send you a One Time Password (OTP) by SMS to your registered mobile phone as an additional security step.

      Be sure to select a secure password:
      
1. Minimum eight characters, alphanumeric and case-sensitive.
2. Combine letters and numbers.
3. Avoid obvious choices like names or birthdates.
4. Never share passwords.
5. Change passwords frequently.`,
    },
    {
      id: 2,
      title: "c. Session Time-Out",
      content: `The System will automatically log you out from Electronic Trading after few minutes of inactivity. This reduces the risk of others accessing your information from your unattended computer.`,
    },
    {
      id: 3,
      title: "d. Firewall",
      content: `Tharwat's computer systems are protected 24 hours a day by a powerful firewall that blocks unauthorized entry.`,
    },
    {
      id: 4,
      title: "e. How can I help protect myself?",
      content: `With a few simple steps, you can help protect your Tharwat Investment accounts and personal information from fake emails and Web sites:

1. Delete suspicious emails without opening them. If you do open a suspicious email, do not open any
attachments or click on any links it may contain.

2. Never provide sensitive account or personal information in response to an email.

3. Install and regularly update virus protection software.

4. Keep your computer operating system and Web browser updated.`,
    },
    {
      id: 5,
      title: "f. Security Measures & Controls",
      content: `The System uses several different methods to protect your information:

      SSL (Secure Socket Layer) protocol is an encryption method to create a secure environment for transferring information between your browser and Tharwat Investment.

      Secure Socket Layer (SSL) protects data in three key ways:

1. Authentication ensures that you are communicating with the correct server. This prevents another computer from impersonating Tharwat.

2. Encryption scrambles transferred data.

3. Data Integrity verifies that the information sent by you to Tharwat wasn't altered during the transfer. The System detects if data was added or deleted after you sent the message. If any tampering has occurred, the connection is dropped.`,
    },
    {
      id: 6,
      title: "g. User Responsibilities",
      content: `While Tharwat Investment continues to evaluate and implement the latest improvements in Internet security technology, as a user of the System you also have responsibility for the security of your information and should always follow the recommendations listed below:

1. Use the latest version of your Internet web browser
2. Keep your login password confidential.
3. Be sure others are not watching when you login to the System.
4. Never leave your computer unattended while logged into the System.
5. Click the “Log Out” button when you are finished using the System to end your session securely.
6. Keep your computer free of viruses or malware. Use virus protection software to routinely check for a virus on your computer. Never allow a virus to remain on your computer while accessing the System.`,
    },
  ],
};

export const informationSecurityArabic = {
  heading: "أمن المعلومات",
  download: "تحميل قوات الدفاع الشعبي",
  content: [
    {
      id: 0,
      title: "مقدمة",
      content: `(. ه	ذا ويتطلب تنفي	ذ ه	ذهالنظ	ام"( بتوف	ير خ	دمات الت	داول والإبلاغ الإلك	تروني ع	بر بواب	ة العملاء )"ج	دوىتس	عد ش	ركة ج	دوى للاس	تثمار )"
الخ	دمات وج	ود إط	ار أم	ني رص	ين يحميكم أنتم وبيان	ات مؤسس	تكم من أي خ	رقٍ خ	ارجي. نحن مل	تزمون بالتع	اون م	ع ش	ركائنا	 التقن	يين لتوف	ير
أأمن بيئ		ة تش		غيلية ممكن		ة لعملائن		ا ومس		تخدمينا. وتُلخّص المعلوم		ات ال		واردة	 أدن		اه إطارن		ا الأم		ني ال		ذي يتض		من أح		دث التقني		ات، وك		ذلك

مسؤولياتكم كمستخدمين للنظام فيما يختص بالأوجه الأمنية. هذا ويشتمل إطارنا على عدة مستويات لتأمين البيانات والمعلومات.`,
    },
    {
      id: 1,
      title: "كلمة المرور",
      content: `بع	د التس	جيل ل	دى ج	دوى لاس	تخدام النظ	ام، س	وف تحص	لون	 على اس	م مس	تخدم وكلم	ة م	رور ع	بر رس	الة نص	ية قص	يرة	 أو رس	الة إلكتروني	ة.
وفي أول مرة تقومون بتسجيل الدخول إلى النظام عبر كلمة المرور الجديدة، سوف يُطلب منكم تغييرها.

بح	ال قمتم بإدخ	ال كلم	ة م	رور خاطئ	ة بع	د ثلاث مح	اولات، فلن تتمكن	وا من تس	جيل ال	دخول إلى حس	ابكم وس	يتعيّن عليكم الاتص	ال بج	دوى
للاستثمار. وبحال نسيتم كلمة المرور، يُمكن إعادة تعيينها بسهولة من خلال الضغط على راب	ط "نس	يت كلم	ة الم	رور؟" الموج	ود على ص	فحة

تسجيل الدخول	 للحصول	 على كلمة مرور جديدة	 عبر رسالة إلكترونية.

يرجى العلم بأنه في كل مرة تقوم فيها بتسجيل دخول	 ناجح إلى حسابك، سوف يُرسل النظام لك "كلم	ة م	رور لم	رة واح	دة" ع	بر رس	الة نص	ية
قصيرة	 إلى رقم الهاتف النقال المُسجل، وذلك كخطوة	 تأمين إضافية.

كما يرجى مراعاة	 الآتي عند تعيين كلمة المرور:

ألا تقل كلمة المرور عن ثمانية أحرف وأن تتكون من الأرقام والحروف، سواء الأحرف الكبيرة أو الصغيرة.1
كلمات المرور الأكثر أمانا هي تلك التي تجمع ما بين الحروف والأرقام.2
ننصحك بعدم استخدام كلمات مرور بديهية مثل اسمك أو تاريخ ميلادك.3
امتنع تماما عن مشاركة أي شخص كلمة مرورك.4
احرص على تغيير كلمة المرور بشكلٍ متكرر .5`,
    },
    {
      id: 2,
      title: "انتهاء زمن الجلسة",
      content: `سوف يُسجل النظام خروجا تلقائيا من خدمة التداول الإلكتروني وذلك بحال مرور عدة دقائق دون نشاط أو حركة، مما يُقلل من مخاطر قي	ام
الآخرين بالوصول	 إلى معلوماتك، بحال ترك جهازك متاحا دون مراقبة.`,
    },
    {
      id: 3,
      title: "جدار الحماية",
      content: `يعمل جدار حماية رصين على حماية أنظمة ثروات على مدار 24 ساعة يوميا، ويحجب أي دخول غير مُصرّح	 به إلى النظام.`,
    },
    {
      id: 4,
      title: "كيف يمكنني توفير الحماية الذاتية؟",
      content: `يُمكنك حماية حساباتك ومعلوماتك الشخصية لدى ج	دوى للاس	تثمار ض	د رس	ائل البري	د الإلك	تروني والمواق	ع الإلكتروني	ة الوهمي	ة، باتب	اع ع	دة
خطوات مٌبسطة:

حذف الرسائل الإلكترونية المُريبة دون فتحها أو فتح أية مرفقات	 أو الضغط على أي روابط قد تحويها تلك الرسائل.1
الامتناع عن إرسال أي معلومات حساسة أو شخصية ردا على أي رسالة إلكترونية.2
تثبيت وتحديث برمجيات الحماية ضد فيروسات الحاسوب بانتظام .3
المداومة على تحديث نظام تشغيل الحاسوب ومتصفح الإنترنت.4`,
    },
    {
      id: 5,
      title: "الإجراءات والضوابط الأمنية",
      content: `يستخدم النظام العديد من الوسائل المختلفة لحماية معلوماتك:

( هو وسيلة تشفير لخلق بيئة آمن	ة لنق	ل المعلوم	ات بين متص	فحك وبين ج	دوى للاس	تثمار، حيث يق	ومSSLبروتوكول طبقة المنافذ الآمنة  )
بحماية بياناتك عبر ثلاثة طرق رئيسية:

المصادقة.1 تضمن قيامك بالتواصل مع الخادم الصحيح، مما يمنع أي جهاز حاسوب آخر من انتحال هوية ثروات
التشفير.2 يعمل على خلط البيانات المنقولة

سلامة البيانات للتحقق من أن المعلومات التي تُرسلها إلى ثروات لم يتم تغييرها خلال عملية النقل، حيث يقوم النظام برصد م		ا إذا ك		ان.3
قد تمت إضافة أو حذف البيانات بعد إرسالك الرسالة. وبحال حدوث أي تلاعب، يتم قطع الاتصال.`,
    },
    {
      id: 6,
      title: "مسؤوليات المستخدم",
      content: `بينم		ا تس		عى ج		دوى إلى تق		ييم وتنفي		ذ آخ		ر تحس		ينات وتقني		ات الأمن المعلوم		اتي، ف		أنت باعتب		ارك مس		تخدما للنظ		ام، تتحم		ل مس		ؤولية أمن
معلوماتك، وعليك دوما اتباع التوصيات التالية:

استخدام آخر وأحدث إصدار لمتصفح الإنترنت  .1
المحافظة	 على سرية كلمة المرور  .2
التأكد من عدم مراقبة أي شخص لك أثناء تسجيل الدخول إلى النظام  .3
الامتناع عن ترك جهازك دون مراقبة عند تسجيل الدخول	 إلى النظام.4
الضغط على زر "تسجيل الخروج" عند انتهائك من استخدام النظام لإنهاء جلستك بأمان	.5
حافظ على خلو جهازك من الفيروس		ات أو البرمجي		ات الم		دمرة،	 واس		تخدم ب		رامج الحماي		ة لإج		راء فحص دوري لجه		ازك لا تس		مح.6

ببقاء الفيروسات على جهازك عند الدخول	 إلى النظام`,
    },
  ],
};

export const alertTabs = (getContentKey) => [
  {
    id: 0,
    name: getContentKey("active_alert"),
  },
  {
    id: 1,
    name: getContentKey("triggered_alert"),
  },
  {
    id: 2,
    name: getContentKey("expired_alert"),
  },
];

export const loserArray = (getContentKey) => [
  {
    id: 1,
    name: getContentKey("losers"),
    type: "7",
  },
  {
    id: 2,
    name: getContentKey("gainers"),
    type: "8",
  },
];

export const alertListData = [
  {
    id: 0,
    title: "DU",
    description: "DU",
    type: "Open",
    price: 4.0,
    days: 4,
  },
  {
    id: 1,
    title: "DFM",
    description: "DFM",
    type: "Bid",
    price: 100.0,
    days: 1,
  },
];

export const alertOptions = [
  {
    id: 0,
    label: "modify_alert",
    key: "modify",
  },
  {
    id: 1,
    label: "delete",
    key: "delete",
  },
];

export const watchListModalData = [
  {
    id: 0,
    label: "t22",
  },
  {
    id: 1,
    label: "Petro",
  },
  {
    id: 2,
    label: "t1",
  },
];

export const months = [
  {
    id: "01",
    name: "Jan",
    month: "January",
  },
  {
    id: "02",
    name: "Feb",
    month: "Feburary",
  },
  {
    id: "03",
    name: "Mar",
    month: "March",
  },
  {
    id: "04",
    name: "Apr",
    month: "April",
  },
  {
    id: "05",
    name: "May",
    month: "May",
  },
  {
    id: "06",
    name: "Jun",
    month: "June",
  },
  {
    id: "07",
    name: "Jul",
    month: "July",
  },
  {
    id: "08",
    name: "Aug",
    month: "August",
  },
  {
    id: "09",
    name: "Sep",
    month: "September",
  },
  {
    id: 10,
    name: "Oct",
    month: "October",
  },
  {
    id: 11,
    name: "Nov",
    month: "November",
  },
  {
    id: 12,
    name: "Dec",
    month: "December",
  },
];

export const faqsSections = (getContentKey) => [
  {
    id: 0,
    title: getContentKey("general"),
  },
  {
    id: 1,
    title: getContentKey("funds"),
  },
  {
    id: 2,
    title: getContentKey("trading"),
  },
  {
    id: 3,
    title: getContentKey("transfers"),
  },
  {
    id: 4,
    title: getContentKey("reports"),
  },
  {
    id: 5,
    title: getContentKey("client_info"),
  },
];

export const accountSetupTerms = `This Agreement is entered into as of [Date] between [Party A] and [Party B] (collectively referred to as "Parties"). The Parties agree to the terms outlined herein regarding [specific purpose or subject matter]. This document establishes the roles, responsibilities, and obligations of both Parties to ensure successful collaboration. Any amendments or modifications to this Agreement must be made in writing and mutually agreed upon. This Agreement is binding and enforceable under the applicable laws of [jurisdiction].`;

export const order_status_array = [
  {
    id: 0,
    name: "All",
  },
  {
    id: 1,
    name: "Outstanding",
  },
  {
    id: 2,
    name: "Filled",
  },
  {
    id: 3,
    name: "Cancelled",
  },
];

export const clientDetailTabs = (getContentKey) => [
  {
    id: 0,
    name: getContentKey("main_info"),
  },
  {
    id: 1,
    name: getContentKey("portfolios"),
  },
];

export const portfolioMarketColumn = (getContentKey) => [
  {
    label: getContentKey("market_accounts"),
    dataIndex: "marketAccountName",
    key: "marketAccountName",
    align: "left",
    width: 200,
  },
  {
    label: getContentKey("trading_number"),
    dataIndex: "tradingNumber",
    key: "tradingNumber",
  },
  {
    label: getContentKey("investor_id"),
    dataIndex: "investorId",
    key: "investorId",
  },
];

export const portfolioCashColumn = (getContentKey) => [
  {
    label: getContentKey("cash_account"),
    dataIndex: "cashAccountNumber",
    key: "cashAccountNumber",
    align: "left",
    width: 200,
  },
  {
    label: getContentKey("cash_type"),
    dataIndex: "cashType",
    key: "cashType",
  },
  {
    label: getContentKey("currency"),
    dataIndex: "cashCurrency",
    key: "cashCurrency",
  },
];
export const orderStatusColumn = (getContentKey, onClick) => [
  {
    label: getContentKey("order_no"),
    dataIndex: "orderNo",
    key: "orderNo",
    align: "left",
  },
  {
    label: getContentKey("funds"),
    dataIndex: "fund",
    key: "fund",
    align: "left",
  },
  {
    label: getContentKey("units"),
    dataIndex: "units",
    key: "units",
    align: "left",
  },
  {
    label: getContentKey("status"),
    dataIndex: "status",
    key: "status",
    align: "left",
  },
  {
    label: getContentKey("date"),
    dataIndex: "date",
    key: "date",
    align: "left",
  },
  {
    label: getContentKey("action"),
    dataIndex: "action",
    key: "action",
    align: "left",
    width: 100,
    isActions: true,
  },
];

export const requestTypes = (getContentKey) => [
  { id: 1, name: getContentKey("incident") },
  { id: 2, name: getContentKey("request_information") },
  { id: 3, name: getContentKey("service_request") },
];

export const subscribeCardData = {
  title: "Tharwat 17th for Real Estate Develepment Fund",
  percent: 82,
  discription:
    "Development of a luxury mixed-use office complex in Al Malqa, north Riyadh, on Prince Turki Al Awwal Road. The project includes a 4-star hotel, serviced apartments, office spaces, and retail areas, in partnership with Rasaf Investment.",
  fundPrice: "1034 Million SAR",
  duration: "4 (1+1)",
  land: "27,318.46 m²",
  year: "2024",
};

export const languageOptions = [
  { id: 3, label: "English" },
  { id: 4, label: "عربي" },
];

export const accountManagementOptions = [
  { id: 1089, name: "Single" },
  { id: 1090, name: "Joint (any two)" },
  { id: 1091, name: "Other, please specify" },
];

export const countries_length = [
  { code: "AD", label: "Andorra", phone: "376", phoneLength: 6 },
  { code: "AE", label: "United Arab Emirates", phone: "971", phoneLength: 9 },
  { code: "AF", label: "Afghanistan", phone: "93", phoneLength: 9 },
  { code: "AG", label: "Antigua and Barbuda", phone: "1-268", phoneLength: 10 },
  { code: "AI", label: "Anguilla", phone: "1-264", phoneLength: 10 },
  { code: "AL", label: "Albania", phone: "355", phoneLength: 9 },
  { code: "AM", label: "Armenia", phone: "374", phoneLength: 6 },
  { code: "AO", label: "Angola", phone: "244", phoneLength: 9 },
  { code: "AQ", label: "Antarctica", phone: "672", phoneLength: 6 },
  { code: "AR", label: "Argentina", phone: "54", phoneLength: 8 },
  { code: "AS", label: "American Samoa", phone: "1-684", phoneLength: 10 },
  { code: "AT", label: "Austria", phone: "43", phoneLength: 11 },
  {
    code: "AU",
    label: "Australia",
    phone: "61",
    suggested: true,
    phoneLength: 9,
  },
  { code: "AW", label: "Aruba", phone: "297", phoneLength: 7 },
  { code: "AX", label: "Alland Islands", phone: "358", min: 7, max: 10 },
  { code: "AZ", label: "Azerbaijan", phone: "994", phoneLength: 9 },
  { code: "BA", label: "Bosnia and Herzegovina", phone: "387", phoneLength: 8 },
  { code: "BB", label: "Barbados", phone: "1-246", phoneLength: 10 },
  { code: "BD", label: "Bangladesh", phone: "880", phoneLength: 10 },
  { code: "BE", label: "Belgium", phone: "32", phoneLength: 9 },
  { code: "BF", label: "Burkina Faso", phone: "226", phoneLength: 8 },
  { code: "BG", label: "Bulgaria", phone: "359", phoneLength: 9 },
  { code: "BH", label: "Bahrain", phone: "973", phoneLength: 8 },
  { code: "BI", label: "Burundi", phone: "257", phoneLength: 8 },
  { code: "BJ", label: "Benin", phone: "229", phoneLength: 8 },
  { code: "BL", label: "Saint Barthelemy", phone: "590", phoneLength: 9 },
  { code: "BM", label: "Bermuda", phone: "1-441", phoneLength: 10 },
  { code: "BN", label: "Brunei Darussalam", phone: "673", phoneLength: 7 },
  { code: "BO", label: "Bolivia", phone: "591", phoneLength: 9 },
  { code: "BR", label: "Brazil", phone: "55", phoneLength: 11 },
  { code: "BS", label: "Bahamas", phone: "1-242", phoneLength: 10 },
  { code: "BT", label: "Bhutan", phone: "975", phoneLength: 7 },
  { code: "BV", label: "Bouvet Island", phone: "47", phoneLength: 10 },
  { code: "BW", label: "Botswana", phone: "267", phoneLength: 7 },
  { code: "BY", label: "Belarus", phone: "375", phoneLength: 9 },
  { code: "BZ", label: "Belize", phone: "501", phoneLength: 7 },
  { code: "CA", label: "Canada", phone: "1", suggested: true, phoneLength: 10 },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    phone: "61",
    phoneLength: 10,
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    phone: "243",
    phoneLength: 7,
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "236",
    phoneLength: 8,
  },
  { code: "CG", label: "Congo, Republic of the", phone: "242", phoneLength: 9 },
  { code: "CH", label: "Switzerland", phone: "41", phoneLength: 9 },
  { code: "CI", label: "Cote d'Ivoire", phone: "225", phoneLength: 8 },
  { code: "CK", label: "Cook Islands", phone: "682", phoneLength: 5 },
  { code: "CL", label: "Chile", phone: "56", phoneLength: 9 },
  { code: "CM", label: "Cameroon", phone: "237", phoneLength: 9 },
  { code: "CN", label: "China", phone: "86", phoneLength: 11 },
  { code: "CO", label: "Colombia", phone: "57", phoneLength: 10 },
  { code: "CR", label: "Costa Rica", phone: "506", phoneLength: 8 },
  { code: "CU", label: "Cuba", phone: "53", phoneLength: 8 },
  { code: "CV", label: "Cape Verde", phone: "238", phoneLength: 7 },
  { code: "CW", label: "Curacao", phone: "599", phoneLength: 7 },
  { code: "CX", label: "Christmas Island", phone: "61", phoneLength: 9 },
  { code: "CY", label: "Cyprus", phone: "357", phoneLength: 8 },
  { code: "CZ", label: "Czech Republic", phone: "420", phoneLength: 9 },
  {
    code: "DE",
    label: "Germany",
    phone: "49",
    suggested: true,
    phoneLength: 10,
  },
  { code: "DJ", label: "Djibouti", phone: "253", phoneLength: 10 },
  { code: "DK", label: "Denmark", phone: "45", phoneLength: 8 },
  { code: "DM", label: "Dominica", phone: "1-767", phoneLength: 10 },
  { code: "DO", label: "Dominican Republic", phone: "1-809", phoneLength: 10 },
  { code: "DZ", label: "Algeria", phone: "213", phoneLength: 9 },
  { code: "EC", label: "Ecuador", phone: "593", phoneLength: 9 },
  { code: "EE", label: "Estonia", phone: "372", phoneLength: 8 },
  { code: "EG", label: "Egypt", phone: "20", phoneLength: 10 },
  { code: "EH", label: "Western Sahara", phone: "212", phoneLength: 9 },
  { code: "ER", label: "Eritrea", phone: "291", phoneLength: 7 },
  { code: "ES", label: "Spain", phone: "34", phoneLength: 9 },
  { code: "ET", label: "Ethiopia", phone: "251", phoneLength: 9 },
  { code: "FI", label: "Finland", phone: "358", min: 9, max: 11 },
  { code: "FJ", label: "Fiji", phone: "679", phoneLength: 7 },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "500",
    phoneLength: 5,
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "691",
    phoneLength: 7,
  },
  { code: "FO", label: "Faroe Islands", phone: "298", phoneLength: 5 },
  { code: "FR", label: "France", phone: "33", suggested: true, phoneLength: 9 },
  { code: "GA", label: "Gabon", phone: "241", phoneLength: 7 },
  { code: "GB", label: "United Kingdom", phone: "44", phoneLength: 10 },
  { code: "GD", label: "Grenada", phone: "1-473", phoneLength: 10 },
  { code: "GE", label: "Georgia", phone: "995", phoneLength: 9 },
  { code: "GF", label: "French Guiana", phone: "594", phoneLength: 9 },
  { code: "GG", label: "Guernsey", phone: "44", phoneLength: 10 },
  { code: "GH", label: "Ghana", phone: "233", phoneLength: 9 },
  { code: "GI", label: "Gibraltar", phone: "350", phoneLength: 8 },
  { code: "GL", label: "Greenland", phone: "299", phoneLength: 6 },
  { code: "GM", label: "Gambia", phone: "220", phoneLength: 7 },
  { code: "GN", label: "Guinea", phone: "224", phoneLength: 9 },
  { code: "GP", label: "Guadeloupe", phone: "590", phoneLength: 9 },
  { code: "GQ", label: "Equatorial Guinea", phone: "240", phoneLength: 9 },
  { code: "GR", label: "Greece", phone: "30", phoneLength: 10 },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "500",
    phoneLength: 5,
  },
  { code: "GT", label: "Guatemala", phone: "502", phoneLength: 8 },
  { code: "GU", label: "Guam", phone: "1-671", phoneLength: 10 },
  { code: "GW", label: "Guinea-Bissau", phone: "245", phoneLength: 9 },
  { code: "GY", label: "Guyana", phone: "592", phoneLength: 7 },
  { code: "HK", label: "Hong Kong", phone: "852", phoneLength: 8 },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "672",
    phoneLength: 10,
  },
  { code: "HN", label: "Honduras", phone: "504", phoneLength: 8 },
  { code: "HR", label: "Croatia", phone: "385", phoneLength: 9 },
  { code: "HT", label: "Haiti", phone: "509", phoneLength: 8 },
  { code: "HU", label: "Hungary", phone: "36", phoneLength: 9 },
  { code: "ID", label: "Indonesia", phone: "62", phoneLength: 11 },
  { code: "IE", label: "Ireland", phone: "353", phoneLength: 9 },
  { code: "IL", label: "Israel", phone: "972", phoneLength: 9 },
  { code: "IM", label: "Isle of Man", phone: "44", phoneLength: 10 },
  { code: "IN", label: "India", phone: "91", phoneLength: 10 },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "246",
    phoneLength: 7,
  },
  { code: "IQ", label: "Iraq", phone: "964", phoneLength: 10 },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    phone: "98",
    phoneLength: 11,
  },
  { code: "IS", label: "Iceland", phone: "354", phoneLength: 7 },
  { code: "IT", label: "Italy", phone: "39", phoneLength: 10 },
  { code: "JE", label: "Jersey", phone: "44", phoneLength: 10 },
  { code: "JM", label: "Jamaica", phone: "1-876", phoneLength: 10 },
  { code: "JO", label: "Jordan", phone: "962", phoneLength: 9 },
  { code: "JP", label: "Japan", phone: "81", suggested: true, phoneLength: 10 },
  { code: "KE", label: "Kenya", phone: "254", phoneLength: 10 },
  { code: "KG", label: "Kyrgyzstan", phone: "996", phoneLength: 9 },
  { code: "KH", label: "Cambodia", phone: "855", phoneLength: 9 },
  { code: "KI", label: "Kiribati", phone: "686", phoneLength: 8 },
  { code: "KM", label: "Comoros", phone: "269", phoneLength: 7 },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "1-869",
    phoneLength: 10,
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "850",
    phoneLength: 13,
  },
  { code: "KR", label: "Korea, Republic of", phone: "82", phoneLength: 8 },
  { code: "KW", label: "Kuwait", phone: "965", phoneLength: 8 },
  { code: "KY", label: "Cayman Islands", phone: "1-345", phoneLength: 7 },
  { code: "KZ", label: "Kazakhstan", phone: "7", phoneLength: 10 },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "856",
    phoneLength: 9,
  },
  { code: "LB", label: "Lebanon", phone: "961", phoneLength: 8 },
  { code: "LC", label: "Saint Lucia", phone: "1-758", phoneLength: 7 },
  { code: "LI", label: "Liechtenstein", phone: "423", phoneLength: 7 },
  { code: "LK", label: "Sri Lanka", phone: "94", phoneLength: 7 },
  { code: "LR", label: "Liberia", phone: "231", phoneLength: 9 },
  { code: "LS", label: "Lesotho", phone: "266", phoneLength: 8 },
  { code: "LT", label: "Lithuania", phone: "370", phoneLength: 8 },
  { code: "LU", label: "Luxembourg", phone: "352", phoneLength: 9 },
  { code: "LV", label: "Latvia", phone: "371", phoneLength: 8 },
  { code: "LY", label: "Libya", phone: "218", phoneLength: 10 },
  { code: "MA", label: "Morocco", phone: "212", phoneLength: 9 },
  { code: "MC", label: "Monaco", phone: "377", phoneLength: 8 },
  { code: "MD", label: "Moldova, Republic of", phone: "373", phoneLength: 8 },
  { code: "ME", label: "Montenegro", phone: "382", phoneLength: 8 },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    phone: "590",
    phoneLength: 6,
  },
  { code: "MG", label: "Madagascar", phone: "261", phoneLength: 7 },
  { code: "MH", label: "Marshall Islands", phone: "692", phoneLength: 7 },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "389",
    phoneLength: 8,
  },
  { code: "ML", label: "Mali", phone: "223", phoneLength: 8 },
  { code: "MM", label: "Myanmar", phone: "95", min: 7, max: 10 },
  { code: "MN", label: "Mongolia", phone: "976", phoneLength: 8 },
  { code: "MO", label: "Macao", phone: "853", phoneLength: 8 },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "1-670",
    phoneLength: 7,
  },
  { code: "MQ", label: "Martinique", phone: "596", phoneLength: 9 },
  { code: "MR", label: "Mauritania", phone: "222", phoneLength: 8 },
  { code: "MS", label: "Montserrat", phone: "1-664", phoneLength: 10 },
  { code: "MT", label: "Malta", phone: "356", phoneLength: 8 },
  { code: "MU", label: "Mauritius", phone: "230", phoneLength: 8 },
  { code: "MV", label: "Maldives", phone: "960", phoneLength: 7 },
  { code: "MW", label: "Malawi", phone: "265", phoneLength: 9 },
  { code: "MX", label: "Mexico", phone: "52", phoneLength: 10 },
  { code: "MY", label: "Malaysia", phone: "60", phoneLength: 7 },
  { code: "MZ", label: "Mozambique", phone: "258", phoneLength: 12 },
  { code: "NA", label: "Namibia", phone: "264", phoneLength: 7 },
  { code: "NC", label: "New Caledonia", phone: "687", phoneLength: 6 },
  { code: "NE", label: "Niger", phone: "227", phoneLength: 8 },
  { code: "NF", label: "Norfolk Island", phone: "672", phoneLength: 6 },
  { code: "NG", label: "Nigeria", phone: "234", phoneLength: 8 },
  { code: "NI", label: "Nicaragua", phone: "505", phoneLength: 8 },
  { code: "NL", label: "Netherlands", phone: "31", phoneLength: 9 },
  { code: "NO", label: "Norway", phone: "47", phoneLength: 8 },
  { code: "NP", label: "Nepal", phone: "977", phoneLength: 10 },
  { code: "NR", label: "Nauru", phone: "674", phoneLength: 7 },
  { code: "NU", label: "Niue", phone: "683", phoneLength: 4 },
  { code: "NZ", label: "New Zealand", phone: "64", phoneLength: 9 },
  { code: "OM", label: "Oman", phone: "968", phoneLength: 8 },
  { code: "PA", label: "Panama", phone: "507", phoneLength: 8 },
  { code: "PE", label: "Peru", phone: "51", phoneLength: 9 },
  { code: "PF", label: "French Polynesia", phone: "689", phoneLength: 8 },
  { code: "PG", label: "Papua New Guinea", phone: "675", phoneLength: 8 },
  { code: "PH", label: "Philippines", phone: "63", phoneLength: 10 },
  { code: "PK", label: "Pakistan", phone: "92", phoneLength: 10 },
  { code: "PL", label: "Poland", phone: "48", phoneLength: 9 },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "508",
    phoneLength: 6,
  },
  { code: "PN", label: "Pitcairn", phone: "870", phoneLength: 9 },
  { code: "PR", label: "Puerto Rico", phone: "1", phoneLength: 10 },
  { code: "PS", label: "Palestine, State of", phone: "970", phoneLength: 9 },
  { code: "PT", label: "Portugal", phone: "351", phoneLength: 9 },
  { code: "PW", label: "Palau", phone: "680", phoneLength: 7 },
  { code: "PY", label: "Paraguay", phone: "595", phoneLength: 9 },
  { code: "QA", label: "Qatar", phone: "974", phoneLength: 8 },
  { code: "RE", label: "Reunion", phone: "262", phoneLength: 10 },
  { code: "RO", label: "Romania", phone: "40", phoneLength: 10 },
  { code: "RS", label: "Serbia", phone: "381", phoneLength: 9 },
  { code: "RU", label: "Russian Federation", phone: "7", phoneLength: 10 },
  { code: "RW", label: "Rwanda", phone: "250", phoneLength: 9 },
  { code: "SA", label: "Saudi Arabia", phone: "966", phoneLength: 9 },
  { code: "SB", label: "Solomon Islands", phone: "677", phoneLength: 7 },
  { code: "SC", label: "Seychelles", phone: "248", phoneLength: 7 },
  { code: "SD", label: "Sudan", phone: "249", phoneLength: 7 },
  { code: "SE", label: "Sweden", phone: "46", phoneLength: 7 },
  { code: "SG", label: "Singapore", phone: "65", phoneLength: 8 },
  { code: "SH", label: "Saint Helena", phone: "290", phoneLength: 4 },
  { code: "SI", label: "Slovenia", phone: "386", phoneLength: 9 },
  { code: "SJ", label: "Svalbard and Jan Mayen", phone: "47", phoneLength: 8 },
  { code: "SK", label: "Slovakia", phone: "421", phoneLength: 9 },
  { code: "SL", label: "Sierra Leone", phone: "232", phoneLength: 8 },
  { code: "SM", label: "San Marino", phone: "378", phoneLength: 10 },
  { code: "SN", label: "Senegal", phone: "221", phoneLength: 9 },
  { code: "SO", label: "Somalia", phone: "252", phoneLength: 9 },
  { code: "SR", label: "Suriname", phone: "597", phoneLength: 7 },
  { code: "SS", label: "South Sudan", phone: "211", phoneLength: 7 },
  { code: "ST", label: "Sao Tome and Principe", phone: "239", phoneLength: 7 },
  { code: "SV", label: "El Salvador", phone: "503", phoneLength: 8 },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "1-721",
    phoneLength: 10,
  },
  { code: "SY", label: "Syrian Arab Republic", phone: "963", phoneLength: 7 },
  { code: "SZ", label: "Swaziland", phone: "268", phoneLength: 8 },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "1-649",
    phoneLength: 10,
  },
  { code: "TD", label: "Chad", phone: "235", phoneLength: 6 },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "262",
    phoneLength: 10,
  },
  { code: "TG", label: "Togo", phone: "228", phoneLength: 8 },
  { code: "TH", label: "Thailand", phone: "66", phoneLength: 9 },
  { code: "TJ", label: "Tajikistan", phone: "992", phoneLength: 9 },
  { code: "TK", label: "Tokelau", phone: "690", phoneLength: 5 },
  { code: "TL", label: "Timor-Leste", phone: "670", phoneLength: 7 },
  { code: "TM", label: "Turkmenistan", phone: "993", phoneLength: 8 },
  { code: "TN", label: "Tunisia", phone: "216", phoneLength: 8 },
  { code: "TO", label: "Tonga", phone: "676", phoneLength: 5 },
  { code: "TR", label: "Turkey", phone: "90", phoneLength: 11 },
  { code: "TT", label: "Trinidad and Tobago", phone: "1-868", phoneLength: 7 },
  { code: "TV", label: "Tuvalu", phone: "688", phoneLength: 5 },
  {
    code: "TW",
    label: "Taiwan, Province of China",
    phone: "886",
    phoneLength: 9,
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "255",
    phoneLength: 7,
  },
  { code: "UA", label: "Ukraine", phone: "380", phoneLength: 9 },
  { code: "UG", label: "Uganda", phone: "256", phoneLength: 7 },
  {
    code: "US",
    label: "United States",
    phone: "1",
    suggested: true,
    phoneLength: 10,
  },
  { code: "UY", label: "Uruguay", phone: "598", phoneLength: 8 },
  { code: "UZ", label: "Uzbekistan", phone: "998", phoneLength: 9 },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "379",
    phoneLength: 10,
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "1-784",
    phoneLength: 7,
  },
  { code: "VE", label: "Venezuela", phone: "58", phoneLength: 7 },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "1-284",
    phoneLength: 7,
  },
  { code: "VI", label: "US Virgin Islands", phone: "1-340", phoneLength: 10 },
  { code: "VN", label: "Vietnam", phone: "84", phoneLength: 9 },
  { code: "VU", label: "Vanuatu", phone: "678", phoneLength: 5 },
  { code: "WF", label: "Wallis and Futuna", phone: "681", phoneLength: 6 },
  { code: "WS", label: "Samoa", phone: "685", phoneLength: 7 },
  { code: "XK", label: "Kosovo", phone: "383", phoneLength: 8 },
  { code: "YE", label: "Yemen", phone: "967", phoneLength: 9 },
  { code: "YT", label: "Mayotte", phone: "262", phoneLength: 9 },
  { code: "ZA", label: "South Africa", phone: "27", phoneLength: 9 },
  { code: "ZM", label: "Zambia", phone: "260", phoneLength: 9 },
  { code: "ZW", label: "Zimbabwe", phone: "263", phoneLength: 9 },
];

export const buyOrder = [
  {
    id: 1,
    name: "order 1",
  },
  {
    id: 2,
    name: "order 2",
  },
  {
    id: 3,
    name: "order 3",
  },
  {
    id: 4,
    name: "order 4",
  },
];

export const reportTabs = [
  { id: 1, label: "account_statements" },
  { id: 2, label: "fund_fact_sheets" },
  { id: 3, label: "fund_customer_statements" },
];

export const transactionTabs = [
  { id: 1, label: "latest_transaction", key: "latest" },
  { id: 2, label: "show_all", key: "all" },
];

export const myInvestmentsFundsData = [
  {
    id: 1,
    fund_name: "Tharwat Real Estate 17th Fund",
    details: [
      {
        units_owned: 500,
        cost_of_units: "5000",
        current_nav: "5000",
        invested_capital: "488983.92",
        capital_distributions: null,
        net_invested_capital: "488983.92",
        dividend_distributions: null,
        capital_gains_distributions: null,
        market_value: "488983.92",
        total_proceeds: null,
        realized_gains: null,
        unrealized_gains: "1249.23",
        net_gains: "1249.23",
      },
    ],
    chartData: {
      Yearly: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "OP Fund",
            // Data points adjusted to create a peak near 480 in Sep
            data: [100, 130, 90, 100, 80, 150, 180, 200, 480, 150, 120, 150],
            borderColor: "#441133", // Dark color for OP Fund
            borderWidth: 2,
            tension: 0.4,
            fill: false,
            pointRadius: 0, // Hides data points
          },
          {
            label: "Gool Fund",
            // Data points adjusted to create a peak near 160 in Sep
            data: [50, 70, 120, 110, 60, 80, 100, 120, 160, 100, 90, 95],
            borderColor: "#D8A7CA", // Light pink color for Gool Fund
            borderWidth: 2,
            tension: 0.4,
            fill: false,
            pointRadius: 0, // Hides data points
          },
        ],
      },
      Monthly: {
        labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
        datasets: [
          {
            label: "OP Fund",
            data: [100, 200, 150, 250],
            borderColor: "#441133",
            tension: 0.4,
            pointRadius: 0,
            borderWidth: 2,
          },
          {
            label: "Gool Fund",
            data: [80, 160, 120, 200],
            borderColor: "#D8A7CA",
            tension: 0.4,
            pointRadius: 0,
            borderWidth: 2,
          },
        ],
      },
    },
  },
  {
    id: 2,
    fund_name: "Saudi Emerging Markets Fund Class C",
    details: [
      {
        units_owned: 500,
        cost_of_units: "5000",
        current_nav: "5000",
        invested_capital: "488983.92",
        capital_distributions: null,
        net_invested_capital: "488983.92",
        dividend_distributions: null,
        capital_gains_distributions: null,
        market_value: "488983.92",
        total_proceeds: null,
        realized_gains: null,
        unrealized_gains: "1249.23",
        net_gains: "1249.23",
      },
    ],
    chartData: {
      Yearly: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "OP Fund",
            // Data points adjusted to create a peak near 480 in Sep
            data: [100, 130, 90, 100, 80, 150, 180, 200, 480, 150, 120, 150],
            borderColor: "#441133", // Dark color for OP Fund
            borderWidth: 2,
            tension: 0.4,
            fill: false,
            pointRadius: 0, // Hides data points
          },
          {
            label: "Gool Fund",
            // Data points adjusted to create a peak near 160 in Sep
            data: [50, 70, 120, 110, 60, 80, 100, 120, 160, 100, 90, 95],
            borderColor: "#D8A7CA", // Light pink color for Gool Fund
            borderWidth: 2,
            tension: 0.4,
            fill: false,
            pointRadius: 0, // Hides data points
          },
        ],
      },
      Monthly: {
        labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
        datasets: [
          {
            label: "OP Fund",
            data: [100, 200, 150, 250],
            borderColor: "#441133",
            tension: 0.4,
            pointRadius: 0,
            borderWidth: 2,
          },
          {
            label: "Gool Fund",
            data: [80, 160, 120, 200],
            borderColor: "#D8A7CA",
            tension: 0.4,
            pointRadius: 0,
            borderWidth: 2,
          },
        ],
      },
    },
  },
];

export const viewfundsData = [
  "July 2020 Saudi Equity Fund - EN",
  "July 2021 Saudi Equity Fund - EN",
  "July 2022 Saudi Equity Fund - EN",
];

export const ticketingHistoryData = [
  {
    id: 1,
    label: "Display Name#1",
    subject: "Change password not working",
    requestType: "Request type#1",
    date: "2023-01-01",
    status: "Open",
  },
  {
    id: 2,
    label: "Display Name#2",
    subject: "Change password not working",
    requestType: "Request type#2",
    date: "2023-01-02",
    status: "Closed",
  },
  {
    id: 3,
    label: "Display Name#3",
    subject: "Change password not working",
    requestType: "Request type#3",
    date: "2023-01-03",
    status: "Pending",
  },
  {
    id: 4,
    label: "Display Name#4",
    subject: "Change password not working",
    requestType: "Request type#4",
    date: "2023-01-04",
    status: "Open",
  },
];

export const myFundReportsData = [
  {
    documentFileName: "compressed_image.jpeg",
    documentFileUrl: images?.building,
    documentId: 486,
    documentName: "compressed_image",
    documentTypeId: 5,
    documentTypeName: "Images",
    fundName: "Tharwat Abha Real Estate Fund",
    longDesc: "Acquisition and infrastructure development of raw land in Abha.",
    fundSize: "450,000,000",
    landArea: "900,000 m²",
    duration: "12.0",
  },
];

export const fundsCustomerStatements = (getContentKey, onClick) => [
  {
    label: getContentKey("date"),
    dataIndex: "date",
    key: "date",
    align: "left",
    isDate: true,
    dateFormat: "DD/MM/YYYY",
    // render: (value) => dayjs(value).format("DD/MM/YYYY")
  },
  {
    label: getContentKey("refNo"),
    dataIndex: "id",
    key: "refNo",
    align: "left",
  },
  {
    label: getContentKey("description"),
    dataIndex: "description",
    key: "description",
    align: "left",
    width: 200,
  },
  {
    label: getContentKey("unitsIssuedOrRedeemed"),
    dataIndex: "units",
    key: "unitsIssuedOrRedeemed",
    align: "left",
    width: 250,
    render: (value) => Number(value).toLocaleString(),
  },
  {
    label: getContentKey("cumulativeUnits"),
    dataIndex: "cumulative_units",
    key: "cumulativeUnits",
    align: "left",
    width: 200,
    render: (value) => Number(value).toLocaleString(),
  },
  {
    label: getContentKey("grossAmount"),
    dataIndex: "gross_amount",
    key: "grossAmount",
    align: "left",
    width: 250,
    render: (value) => Number(value).toLocaleString(),
    isSymbol: true
  },
  {
    label: getContentKey("subRedFee"),
    dataIndex: "fee_amount",
    key: "subRedFee",
    align: "left",
    width: 200,
    render: (value) => Number(value).toLocaleString(),
    isSymbol: true
  },
  {
    label: getContentKey("netAmount"),
    dataIndex: "paid_amount",
    key: "netAmount",
    align: "left",
    width: 250,
    render: (value) => Number(value).toLocaleString(),
    isSymbol: true
  },
  {
    label: getContentKey("navPerUnit"),
    dataIndex: "nav_per_unit",
    key: "navPerUnit",
    align: "left",
    width: 150
  },
  {
    label: getContentKey("realizedGainLoss"),
    dataIndex: "realized_amount",
    key: "realizedGainLoss",
    align: "left",
    width: 200,
    render: (value) => Number(value).toLocaleString(),
    isSymbol: true
  },
];

export const fundsStatementsData = [
  {
    date: "10/09/2017",
    refNo: 227,
    description: "Fund Subscription",
    unitsIssuedOrRedeemed: "1,000,000.00",
    cumulativeUnits: "1,000,000.00",
    grossAmount: "10,000,000.00",
    subRedFee: "200,000.00",
    netAmount: "10,200,000.00",
    navPerUnit: "10.00",
    realizedGainLoss: "0.00",
  },
  {
    date: "10/09/2017",
    refNo: 228,
    description: "Fund Subscription",
    unitsIssuedOrRedeemed: "500,000.00",
    cumulativeUnits: "1,500,000.00",
    grossAmount: "5,000,000.00",
    subRedFee: "100,000.00",
    netAmount: "5,100,000.00",
    navPerUnit: "10.00",
    realizedGainLoss: "0.00",
  },
  {
    date: "31/12/2024",
    refNo: 390,
    description: "Fund Redemption",
    unitsIssuedOrRedeemed: "1,338,750.00",
    cumulativeUnits: "161,250.00",
    grossAmount: "16,908,412.50",
    subRedFee: "0.00",
    netAmount: "16,908,412.50",
    navPerUnit: "12.63",
    realizedGainLoss: "3,520,912.50",
  },
  {
    date: "22/04/2025",
    refNo: 529,
    description: "Fund Redemption",
    unitsIssuedOrRedeemed: "152,792.18",
    cumulativeUnits: "8,457.82",
    grossAmount: "2,377,470.02",
    subRedFee: "0.00",
    netAmount: "2,377,470.02",
    navPerUnit: "15.56",
    realizedGainLoss: "849,548.21",
  },
];

export const fundSummaryData = [
  {
    label: "nav",
    key: "nav",
    value: 27.77,
  },
  {
    label: "shares_held",
    key: "sharesHeld",
    value: 8457.82,
  },
  {
    label: "cost_holding",
    key: "costOfHolding",
    value: 84578.19,
  },
  {
    label: "current_market_value",
    key: "currentMarketValue",
    value: 234873.64,
  },
  {
    label: "current_unrealized",
    key: "currentUnrealized",
    value: 150295.45,
  },
];

export const fundOptions = [
  {
    fundName: 'Tharwat Al Riyadh Industrial Fund',
    value: 'Tharwat Al Riyadh Industrial Fund',
  },
]

export const investmentEntityTypes = (getContentKey) => [
  {
    id: "TYPE_A",
    value: getContentKey('investment_entity_type')
  },
  {
    id: "TYPE_B",
    value: getContentKey('investment_entity_type_b')
  },
];